const _fc_props = {};
_fc_props.ante_meridiem = 'ryto';
_fc_props.post_meridiem = 'PM';
_fc_props.retry = 'Bandyti dar kartą';
_fc_props.default = 'Numatytasis';
_fc_props.origin = 'Kilmė';
_fc_props.day = 'Diena';
_fc_props.loading = 'Kraunama';
_fc_props.list = 'Sąrašas';
_fc_props.error = 'Klaida';
_fc_props.save = 'Išsaugoti';
_fc_props.delete = 'Ištrinti';
_fc_props.message = 'Žinutė';
_fc_props.logout = 'Atsijungti';
_fc_props.add = 'Pridėti';
_fc_props.remove = 'Pašalinti';
_fc_props.done = 'Atlikta';
_fc_props.other = 'Kita';
_fc_props.interval = 'Intervalas';
_fc_props.time = 'Laikas';
_fc_props.speed = 'Greitis';
_fc_props.longitude = 'Ilguma';
_fc_props.latitude = 'Platuma';
_fc_props.x_minutes = '{0} min.';
_fc_props.errors = 'Klaidos';
_fc_props.general = 'Bendra';
_fc_props.messages = 'Žinutės';
_fc_props.gps_fixes = 'GPS pataisymai';
_fc_props.device_id = 'Įrenginio ID';
_fc_props.vehicle = 'Transporto priemonė';
_fc_props.employee = 'Darbuotojas';
_fc_props.version = 'Versija';
_fc_props.statuses = 'Statusai';
_fc_props.edit = 'Redaguoti';
_fc_props.cancel = 'Atšaukti';
_fc_props.yes = 'Taip';
_fc_props.none = 'Nėra';
_fc_props.item = 'Prekė';
_fc_props.never = 'Niekada';
_fc_props.name = 'Vardas';
_fc_props.average = 'Vidutinis';
_fc_props.items = 'Elementai';
_fc_props.true = 'Tiesa';
_fc_props.status = 'Būsena';
_fc_props.distance = 'Atstumas';
_fc_props.ok = 'Gerai';
_fc_props.login = 'Prisijungti';
_fc_props.next = 'Toliau';
_fc_props.info = 'Informacija';
_fc_props.menu = 'Meniu';
_fc_props.not_available = 'N/A';
_fc_props.back = 'Atgal';
_fc_props.refresh = 'Atnaujinti';
_fc_props.select = 'Pasirinkite';
_fc_props.dispatch = 'Siuntimas';
_fc_props.messaging = 'Žinutės';
_fc_props.plants = 'Augalai';
_fc_props.last_plants = 'Paskutiniai augalai';
_fc_props.vehicle_types = 'Transporto priemonių tipai';
_fc_props.employee_types = 'Darbuotojų tipai';
_fc_props.employee_groups = 'Darbuotojų grupės';
_fc_props.equipment_groups = 'Įrangos grupės';
_fc_props.status_type = 'Būsenos tipas';
_fc_props.job = 'Darbas';
_fc_props.order = 'Užsakymas';
_fc_props.ticket = 'Bilieto Nr.';
_fc_props.small = 'Mažas';
_fc_props.medium = 'Vidutinis';
_fc_props.large = 'Didelis';
_fc_props.reports = 'Ataskaitos';
_fc_props.payroll = 'Darbo užmokestis';
_fc_props.support = 'Pagalba';
_fc_props.username = 'Vartotojo vardas';
_fc_props.all = 'Visi';
_fc_props.question = 'Klausimas';
_fc_props.select_employee = 'Pasirinkite darbuotoją';
_fc_props.phone = 'Telefonas';
_fc_props.january = 'Sausis';
_fc_props.february = 'vasaris';
_fc_props.march = 'Kovas';
_fc_props.april = 'Balandis';
_fc_props.may = 'Gegužė';
_fc_props.june = 'Birželis';
_fc_props.july = 'Liepa';
_fc_props.august = 'Rugpjūtis';
_fc_props.september = 'Rugsėjis';
_fc_props.october = 'Spalis';
_fc_props.november = 'Lapkritis';
_fc_props.december = 'Gruodis';
_fc_props.are_you_sure_you_want_to_delete = 'Ar tikrai norite ištrinti';
_fc_props.unknown = 'Nežinoma';
_fc_props.invalid_date_range_report_is_limited_to_x_days = 'Neteisingas dienų diapazonas: ataskaita gali būti apribota iki {0} dienų';
_fc_props.select_all = 'Pasirinkti viską';
_fc_props.resolution = 'Rezoliucija';
_fc_props.equipment = 'Įranga';
_fc_props.totals = 'Iš viso';
_fc_props.region = 'Regionas';
_fc_props.no_data = 'Nėra duomenų';
_fc_props.hotspot = 'Karštoji vieta';
_fc_props.hotspot_type = 'Karštosios zonos tipas';
_fc_props.datetime = 'Data / laikas';
_fc_props.address = 'Adresas';
_fc_props.retrieving_address = 'Gaunamas adresas...';
_fc_props.address_not_found = 'Adresas nerastas';
_fc_props.active_time = 'Aktyvus laikas';
_fc_props.destination_time = 'Kelionės tikslo laikas';
_fc_props.complete_time = 'Pilnas laikas';
_fc_props.status_report = 'Būsenos ataskaita';
_fc_props.export_report = 'Eksportuoti ataskaitą';
_fc_props.download_report = 'Atsisiųsti ataskaitą';
_fc_props.view_report = 'Peržiūrėti ataskaitą';
_fc_props.duration = 'Trukmė';
_fc_props.min = 'Min.';
_fc_props.start_date_time = 'Pradžios data / laikas';
_fc_props.select_start_date = 'Pasirinkite pradžios datą';
_fc_props.end_date_time = 'Pabaigos data / laikas';
_fc_props.select_end_date = 'Pasirinkite pabaigos datą';
_fc_props.trip_time = 'Kelionės laikas';
_fc_props.travel_time = 'Kelionės laikas';
_fc_props.description = 'Aprašymas';
_fc_props.map_controls = 'Žemėlapio valdikliai';
_fc_props.road = 'Kelias';
_fc_props.aerial = 'Antenos';
_fc_props.hybrid = 'Hibridas';
_fc_props.trip = 'Kelionė';
_fc_props.map = 'Žemėlapis';
_fc_props.plant = 'Augalas';
_fc_props.select_date = 'Pasirinkite datą';
_fc_props.apply = 'Taikyti';
_fc_props.save_settings = 'Išsaugoti nustatymus';
_fc_props.false = 'Neteisinga';
_fc_props.delete_confirmation = 'Ištrynimo patvirtinimas';
_fc_props.last_name = 'Pavardė';
_fc_props.none_selected = 'Niekas nepasirinkta';
_fc_props.start_date = 'Pradžios data';
_fc_props.group_by = 'Grupuoti pagal';
_fc_props.equipment_employee = 'Įranga / Darbuotojas';
_fc_props.inactive = 'Neaktyvus';
_fc_props.active = 'Aktyvus';
_fc_props.note_checking_may_affect_performance = 'Pastaba: patikrinimas gali turėti įtakos našumui';
_fc_props.show_distancefuel_used = 'Rodyti atstumą / sunaudotą kurą';
_fc_props.mins = 'Min.';
_fc_props.threshold_time = 'Slenksčio laikas';
_fc_props.include_voided_tickets = 'Įtraukti anuliuotus bilietus';
_fc_props.note_all_times_listed_are_in_minutes = 'Pastaba: visas nurodytas laikas yra minutėmis';
_fc_props.please_select_a_job_order_or_equipment = 'Pasirinkite darbą, užsakymą, gamyklą, įrangą arba darbuotoją';
_fc_props.device = 'Įrenginys';
_fc_props.select_equipment = 'Pasirinkite įrangą';
_fc_props.on_enter = 'Įvedus';
_fc_props.on_exit = 'Išeinant';
_fc_props.all_equipment_types = 'Visų tipų įranga';
_fc_props.summary = 'Santrauka';
_fc_props.units = {};
_fc_props.units.liters = 'Litrai';
_fc_props.type = 'Tipas';
_fc_props.no_data_available = 'Nėra duomenų';
_fc_props.menu = {};
_fc_props.menu.reports = {};
_fc_props.menu.reports.title = {};
_fc_props.menu.reports.title.breakdown = 'Suskaidymas';
_fc_props.menu.reports.title.distance_and_fuel_by_region = 'Atstumas ir degalai pagal regionus';
_fc_props.menu_settings_title_settings = 'Nustatymai';
_fc_props.menu_settings_title_alerts = 'Įspėjimai';
_fc_props.menu.settings = {};
_fc_props.menu.settings.title = {};
_fc_props.menu.settings.title.equipment = 'Įranga';
_fc_props.menu_settings_title_hotspots_regions = 'Karštieji taškai ir regionai';
_fc_props.days = '{0} diena(-os)';
_fc_props.home = 'Pradžia';
_fc_props.find = 'Rasti';
_fc_props.close_this_panel = 'uždaryti šį skydelį';
_fc_props.filters = 'Filtrai';
_fc_props.start = 'Pradėti';
_fc_props.end = 'Pabaiga';
_fc_props.location_details = 'Vietos informacija';
_fc_props.first_name = 'Vardas';
_fc_props.material_per_hour = 'Medžiaga per valandą';
_fc_props.equipment_pound = 'Įrangos numeris';
_fc_props.equipment_type = 'Įrangos tipas';
_fc_props.options = 'Parinktys';
_fc_props.zoom_on_cursor_position = 'Priartinti pagal žymeklio padėtį';
_fc_props.display_equipment_identifier = 'Rodyti įrangos identifikatorių';
_fc_props.view_equipment = 'Peržiūrėti įrangą';
_fc_props.view_hotspots = 'Peržiūrėti karštąsias vietas';
_fc_props.view_regions = 'Peržiūrėti regionus';
_fc_props.use_standard_filters = 'Naudoti standartinius filtrus';
_fc_props.home_plant = 'Naminis augalas';
_fc_props.last_plant = 'Paskutinis augalas';
_fc_props.equip_types = 'Įrangos tipai';
_fc_props.equip_groups = 'Įrangos grupės';
_fc_props.orders = 'Užsakymai';
_fc_props.trakitall = 'TrakitALL';
_fc_props.use_equipment_filter = 'Naudoti įrangos filtrą';
_fc_props.all_selected = 'Visi pasirinkti';
_fc_props.of = 'Iš';
_fc_props.your_map_session_has_expired = 'Jūsų žemėlapio seansas baigėsi. Atnaujinkite puslapį.';
_fc_props.equipment_short = 'Įrengti.';
_fc_props.job_info_for = 'Darbo informacija';
_fc_props.order_info_for = 'Užsakymo informacija';
_fc_props.ticket_info_for_vehicle = 'Informacija apie transporto priemonės bilietus';
_fc_props.inbox = 'Gautieji';
_fc_props.outbox = 'Siunčiamieji';
_fc_props.alerts = 'Įspėjimai';
_fc_props.critical = 'Kritinis';
_fc_props.important = 'Svarbu';
_fc_props.informational = 'Informacinis';
_fc_props.customer = 'Klientas';
_fc_props.view_routes = 'Peržiūrėti maršrutus';
_fc_props.hours_size = 'Valandų dydis';
_fc_props.used_count = 'Naudotų skaičius';
_fc_props.last_login = 'Paskutinis prisijungimas';
_fc_props.last_vehicle = 'Paskutinė transporto priemonė';
_fc_props.regions = 'Regionai';
_fc_props.employee_type = 'Darbuotojo tipas';
_fc_props.driver = 'Vairuotojas';
_fc_props.js_delete = 'Ištrinti';
_fc_props.move = 'Perkelti';
_fc_props.edit_hotspot = 'Redaguoti viešosios prieigos tašką';
_fc_props.adjust_shape = 'Koreguoti formą';
_fc_props.edit_region = 'Redaguoti regioną';
_fc_props.enter_a_start_address = 'Įveskite pradžios adresą';
_fc_props.select_a_start_hotspot = 'Pasirinkite pradinį viešosios prieigos tašką';
_fc_props.failed_to_find_start_hotspot = 'Nepavyko rasti pradinio interneto prieigos taško.';
_fc_props.invalid_latitudelongitude = 'Neteisinga platuma / ilguma';
_fc_props.enter_an_end_address = 'Įveskite galinį adresą';
_fc_props.select_an_end_hotspot = 'Pasirinkite galinį interneto prieigos tašką';
_fc_props.failed_to_find_end_hotspot = 'Nepavyko rasti galinio interneto prieigos taško.';
_fc_props.print = 'Spausdinti';
_fc_props.these_directions_are_for_informational_purposes = 'Šios instrukcijos pateikiamos tik informaciniais tikslais. Jų išsamumas ar tikslumas negarantuojamas. Statybų projektai, eismas ar kiti įvykiai gali lemti, kad realios sąlygos skirsis nuo šių rezultatų.';
_fc_props.enter_an_address = 'Įveskite adresą';
_fc_props.select_a_hotspot = 'Pasirinkite viešosios prieigos tašką';
_fc_props.failed_to_find_hotspot = 'Nepavyko rasti viešosios interneto prieigos taško.';
_fc_props.select_a_vehicle = 'Pasirinkite transporto priemonę';
_fc_props.failed_to_find_vehicle = 'Nepavyko rasti transporto priemonės.';
_fc_props.failed_to_find_address = 'Nepavyko rasti adreso';
_fc_props.failed_to_find_vehicles = 'Nepavyko rasti transporto priemonių pagal paieškos kriterijus.';
_fc_props.get_address = 'Gauti adresą';
_fc_props.results_for = 'Rezultatai pagal užklausą';
_fc_props.error_retrieving_results = 'Klaida gaunant rezultatus';
_fc_props.no_results_found = 'Nerasta rezultatų';
_fc_props.address_is_required = 'Adresas būtinas';
_fc_props.city_is_required = 'Miestas privalomas';
_fc_props.set_location = 'Nustatyti vietą';
_fc_props.set_area_of_interest = 'Nustatyti dominančią sritį';
_fc_props.center_map_here = 'Centruokite žemėlapį čia';
_fc_props.zoom_to_street_level = 'Priartinti iki gatvės lygio';
_fc_props.set_start = 'Nustatyti pradžią';
_fc_props.set_end = 'Nustatyti pabaigą';
_fc_props.delete_node = 'Ištrinti mazgą';
_fc_props.create_a_hotspot = 'Sukurkite viešosios prieigos tašką';
_fc_props.create_a_region = 'Sukurti regioną';
_fc_props.toggle_shapes = 'Perjungti formas';
_fc_props.refresh_map = 'Atnaujinti žemėlapį';
_fc_props.more_options = 'Daugiau parinkčių';
_fc_props.recenter_map = 'Centruoti žemėlapį';
_fc_props.zoom_to_vehicle = 'Priartinti iki transporto priemonės';
_fc_props.apply_filters = 'Taikyti filtrus';
_fc_props.grid_view = 'Tinklelio rodinys';
_fc_props.list_view = 'Sąrašo rodinys';
_fc_props.click_to_sort = 'Spustelėkite, jei norite rūšiuoti';
_fc_props.message_history = 'Pranešimų istorija';
_fc_props.equipment_types = 'Įrangos tipai';
_fc_props.send_message = 'Siųsti žinutę';
_fc_props.last_load = 'Paskutinis pakrovimas';
_fc_props.last_load_on = 'Paskutinis įkrovimas įjungtas';
_fc_props.manual_logout = 'Rankinis atsijungimas';
_fc_props.manual_login = 'Rankinis prisijungimas';
_fc_props.no_employees_logged_in = 'Nėra prisijungusių darbuotojų';
_fc_props.select_phone = 'Pasirinkite telefoną';
_fc_props.you_must_select_a_phone = 'Turite pasirinkti telefoną, įrangą ir darbuotoją';
_fc_props.are_you_sure_you_want_to_logout = 'Ar tikrai norite atsijungti';
_fc_props.fix_time = 'Fiksuoti laiką';
_fc_props.to_next_fix = 'iki kito pataisymo';
_fc_props.minutes_to_next_fix = 'Minutės iki kito pataisymo';
_fc_props.liters = 'Litrai';
_fc_props.destination = 'Kelionės tikslas';
_fc_props.return = 'Grąžinti';
_fc_props.product = 'Produktas';
_fc_props.no_records_found = 'Nerasta jokių įrašų.';
_fc_props.vehicle_type = 'Transporto priemonės tipas';
_fc_props.view_in_map = 'Žiūrėti viską žemėlapyje';
_fc_props.uploads = 'Įkėlimai';
_fc_props.upload_csv_file = 'Įkelti CSV failą';
_fc_props.permanent = 'Nuolatinis';
_fc_props.expire_time = 'Galiojimo laikas';
_fc_props.please_select_x_for_tickets_marked_active = 'Pasirinkite {0}, jei bilietai pažymėti kaip AKTYVŪS';
_fc_props.multiple_tickets_marked_active_for_same_x = 'Keli bilietai pažymėti kaip AKTYVŪS tam pačiam {0}';
_fc_props.delivery_time = 'Pristatymo laikas';
_fc_props.failure_connecting_to_servlet = 'Nepavyko prisijungti prie servleto.';
_fc_props.status_time_summary = 'Būsenos laiko suvestinė';
_fc_props.view_in_map_one = 'Žiūrėti žemėlapyje';
_fc_props.question_report = 'Klausimų ataskaita';
_fc_props.end_date = 'Pabaigos data';
_fc_props.trailer_number = 'Priekabos numeris';
_fc_props.region_panel = 'Regiono skydas';
_fc_props.hotspot_panel = 'Karštųjų taškų skydelis';
_fc_props.shape = 'Forma';
_fc_props.circle = 'Apskritimas';
_fc_props.polygon = 'Daugiakampis';
_fc_props.click_the_map_to_set_the_location = 'Spustelėkite žemėlapį, kad nustatytumėte norimą vietą.';
_fc_props.click_the_map_to_set_the_hotspot_center = 'Spustelėkite žemėlapį, kad nustatytumėte viešosios prieigos taško centrą.';
_fc_props.click_the_map_to_set_the_region_center = 'Spustelėkite žemėlapį, kad nustatytumėte regiono centrą.';
_fc_props.click_and_drag_points = 'Spustelėkite ir vilkite taškus, kad redaguotumėte formą. Spustelėkite IŠSAUGOTI, kad išsaugotumėte pakeitimus.';
_fc_props.size = 'Dydis';
_fc_props.are_you_sure_you_want_to_move_this = 'Ar tikrai norite tai perkelti';
_fc_props.are_you_sure_you_want_to_delete_this = 'Ar tikrai norite tai ištrinti';
_fc_props.please_enter_a_valid_size = 'Įveskite galiojantį dydį';
_fc_props.failed_to_save = 'Nepavyko išsaugoti.';
_fc_props.failed_to_move = 'Nepavyko pajudėti.';
_fc_props.failed_to_delete = 'Nepavyko ištrinti.';
_fc_props.x_hours = '{0} valandos';
_fc_props.hide_hotspots = 'Slėpti karštąsias vietas';
_fc_props.show_regions = 'Rodyti regionus';
_fc_props.show_hotspots = 'Rodyti aktyviuosius taškus';
_fc_props.hide_regions = 'Slėpti regionus';
_fc_props.numeric = 'Skaitmeninis';
_fc_props.message_type = 'Pranešimo tipas';
_fc_props.text = 'Tekstas';
_fc_props.yes_no = 'Taip/Ne';
_fc_props.responses = 'Atsakymai';
_fc_props.disabled = 'Neįgalus';
_fc_props.group_name = 'Grupės pavadinimas';
_fc_props.start_timer = 'Paleidimo laikmatis';
_fc_props.stop_timer = 'Sustabdyti laikmatį';
_fc_props.are_you_sure_you_want_to_delete_the_x_format = 'Ar tikrai norite ištrinti formatą „{0}“?';
_fc_props.phone_number = 'Telefono numeris';
_fc_props.interface_pound = 'Sąsajos Nr.';
_fc_props.field = 'Laukas';
_fc_props.default_label = 'Numatytoji etiketė';
_fc_props.custom_label = 'Pasirinktinė etiketė';
_fc_props.you_must_enter_a_label = 'Turite įvesti žymę.';
_fc_props.enabled = 'Įjungta';
_fc_props.settings = {};
_fc_props.settings.ticket_integration = 'Bilietų integracija';
_fc_props.settings.geofence_off_open_hotspots = 'Geofence nuo atvirų interneto prieigos taškų';
_fc_props.settings.associate_open_hotspots_wticket = 'Asocijuoti atviri prieigos taškai su bilietu';
_fc_props.settings.allow_geofencing_off_of_open_hotspots_or_only_hotspots_associated_with_drivers_ticket = 'Leisti geofencingą atviriems prieigos taškams arba tik tiems prieigos taškams, kurie susieti su vairuotojo bilietu';
_fc_props.settings.whether_or_not_to_associate_open_hotspots_with_tickets_when_a_vehicle_enters_them = 'Ar susieti atviras prieigos taškus su bilietais, kai į juos įvažiuoja transporto priemonė';
_fc_props.settings.void_ticket_without_destination = 'Negaliojantis bilietas be kelionės tikslo';
_fc_props.settings.if_a_ticket_is_received_while_another_one_is_active_if_the_active_ticket_does = 'Jei gautas bilietas yra aktyvus, o pastarasis neturi paskirties vietos, bilietas bus anuliuotas.';
_fc_props.settings.autocreate_hotspots = 'Automatiškai kurti viešosios prieigos taškus';
_fc_props.settings.whether_or_not_to_automatically_create_hotspots_from_the_destination = 'Ar automatiškai kurti prieigos taškus iš paskirties adreso, kai gaunamas bilietas';
_fc_props.settings.autoactivate_ticket_upon_receive = 'Automatiškai aktyvuoti bilietą gavus';
_fc_props.settings.is_the_ticket_active_when_it_is_received_by_trackit_default_true = 'Ar bilietas aktyvus, kai jį gauna „TrackIt“ (numatytoji reikšmė „true“)';
_fc_props.settings.auto_close_active_ticket_upon_receive_minutes = 'Automatiškai uždaryti aktyvų bilietą gavus minutes';
_fc_props.settings.how_long_does_the_current_active_ticket_need_to_have_been_active_before = 'Kiek laiko dabartinis aktyvus bilietas turi būti aktyvus, kad jis būtų automatiškai uždarytas (numatytasis \'\')';
_fc_props.settings.ticket_max_activate_age_minutes = 'Bilietų maksimalus aktyvavimo amžius minutėmis';
_fc_props.settings.how_old_in_minutes_can_a_ticket_be_when_activating_it_in_trackit_default_ = 'Kiek minučių gali būti bilieto galiojimo laikas, kai jis aktyvuojamas „TrackIt“ programoje (numatytasis nustatymas „“)';
_fc_props.settings.max_hotspot_unused_days = 'Maksimalus nenaudojamų viešosios prieigos taškų skaičius dienomis';
_fc_props.settings.sets_the_max_days_a_hotspot_can_be_unused_and_still_be_revived = 'Nustato maksimalų dienų skaičių, per kurį interneto prieigos taškas gali būti nenaudojamas ir vis tiek būti atgaivintas.';
_fc_props.settings.radius_multiplier = 'Spindulio daugiklis';
_fc_props.settings.what_to_multiply_the_radius_by_when_a_ticket_is_received_from_the = 'Iš ko padauginti spindulį, kai gaunamas bilietas iš dispečerinės sistemos';
_fc_props.settings.ticket_message_date_format = 'Kvito pranešimo datos formatas';
_fc_props.am = 'rytas';
_fc_props.pm = 'vakaro';
_fc_props.settings.ticket_message = 'Kvito pranešimas';
_fc_props.settings.add_ticket_element = 'Pridėti bilieto elementą';
_fc_props.driver_performance = 'Vairuotojo našumas';
_fc_props.update_failed_can_not_connect = 'Atnaujinimas nepavyko: nepavyko prisijungti prie servleto.';
_fc_props.company = 'Įmonė';
_fc_props.unknown_error = 'Nežinoma klaida';
_fc_props.selected = 'Pasirinkta';
_fc_props.web_service = 'Žiniatinklio paslauga';
_fc_props.error_processing_request = 'Klaida apdorojant užklausą.';
_fc_props.email_address = 'El. pašto adresas';
_fc_props.id = 'ID';
_fc_props.last_used = 'Paskutinį kartą naudotas';
_fc_props.error_invalid_vehiclenum = 'Klaida Neteisingas transporto priemonės numeris';
_fc_props.error_vehicle_is_not_logged_in = 'Klaida: Transporto priemonė neprisijungusi.';
_fc_props.status_timer = 'Būsenos laikmatis';
_fc_props.warning = 'Įspėjimas';
_fc_props.users = 'Vartotojai';
_fc_props.you_dont_have_access_to_this_page = 'Jūs neturite prieigos peržiūrėti šio puslapio. Norėdami gauti prieigą, susisiekite su sistemos administratoriumi.';
_fc_props.previous_week = 'Praėjusi savaitė';
_fc_props.status_breakdown = 'Būsenos suskirstymas';
_fc_props.select_plant_or_employee_group = 'Turite pasirinkti gamyklą arba darbuotojų grupę.';
_fc_props.cannot_select_plant_and_employee_group = 'Negalite pasirinkti ir gamyklos, ir darbuotojų grupės.';
_fc_props.odometer_must_be_a_number = 'Pradinis odometro rodmuo turi būti skaičius';
_fc_props.ending_odometer_must_be_a_number = 'Galutinis odometro rodmuo turi būti skaičius';
_fc_props.beginning_hour_meter_must_be_a_number = 'Pradinis valandų skaitiklis turi būti skaičius';
_fc_props.ending_hour_meter_must_be_a_number = 'Galutinis valandų skaitiklis turi būti skaičius';
_fc_props.error_loading_status_change_page = 'Įkeliant būsenos keitimo puslapį įvyko klaida.';
_fc_props.x_is_an_invalid_time_format = '{0} yra neteisingas laiko formatas, jis turi būti YYYY-MM-DD HH:MM:SS';
_fc_props.x_for_schedule_login = '{0} prisijungimo planavimui';
_fc_props.x_for_schedule_logout = '{0}, jei norite suplanuoti atsijungimą';
_fc_props.x_for_actual_login = '{0} faktiniam prisijungimui';
_fc_props.x_for_actual_logout = '{0} faktiniam atsijungimui';
_fc_props.by_refreshing_the_time_card_detail = 'Atnaujinus laiko kortelės informaciją, prarasite visus pakeitimus. Tęsti?';
_fc_props.are_you_sure_you_want_to_delete_0 = 'Ar tikrai norite ištrinti {0}?';
_fc_props.settings.command_mobile_ticket_url = 'Komandos mobiliojo bilieto URL';
_fc_props.year = 'Metai';
_fc_props.make = 'Padaryti';
_fc_props.model = 'Modelis';
_fc_props.settings.command_mobile_ticket_password = '„Command Mobile“ bilieto slaptažodis';
_fc_props.settings.command_mobile_ticket_auth_token = '„Command Mobile“ bilietų autentifikavimo žetonas';
_fc_props.target = 'Tikslas';
_fc_props.number_of_digits = 'Skaitmenų skaičius';
_fc_props.number_of_integer_digits = 'Sveikųjų skaičių skaičius';
_fc_props.number_of_fractional_digits = 'Trupmeninių skaitmenų skaičius';
_fc_props.search = 'Paieška';
_fc_props.settings.command_mobile_ticket_date_order = '„Command Mobile“ bilietų datos užsakymas';
_fc_props.settings.command_mobile_ticket_date_length = '„Command Mobile“ bilieto datos ilgis';
_fc_props.settings.command_mobile_ticket_date_separator = '„Command Mobile“ bilieto datos skirtukas';
_fc_props.settings.command_mobile_ticket_slash = '/ (pasvirasis brūkšnys)';
_fc_props.settings.command_mobile_ticket_dash = '- (brūkšnys)';
_fc_props.settings.command_mobile_ticket_period = '. (taškas)';
_fc_props.settings.command_mobile_ticket_space = '(tarpas)';
_fc_props.settings.command_mobile_ticket_time_length = 'Komandinės mobiliosios kortelės laiko trukmė';
_fc_props.settings.command_mobile_ticket_time_separator = '„Command Mobile“ bilietų laiko skirtuvas';
_fc_props.settings.command_mobile_ticket_colon = ': (dvitaškis)';
_fc_props.settings.command_mobile_ticket_time_format = '„Command Mobile“ bilieto laiko formatas';
_fc_props.settings.command_mobile_ticket_use_interface_number = 'Naudoti sąsajos numerį';
_fc_props.language = 'Kalba';
_fc_props.mechanic = 'Mechanikas';
_fc_props.settings.command_mobile_ticket_poll_interval = 'Apklausos intervalas (sekundėmis)';
_fc_props.driving_time = 'Vairavimo laikas';
_fc_props.find_near_plants = 'Rasti netoliese esančius augalus';
_fc_props.please_create_hot_spot_first = 'Pirmiausia sukurkite viešosios prieigos tašką';
_fc_props.pump = 'Siurblys';
_fc_props.please_enter_hot_spot_description = 'Įveskite populiariosios vietos aprašymą';
_fc_props.please_select_a_hot_spot_type = 'Pasirinkite aktyviosios vietos tipą';
_fc_props.settings.command_mobile_ticket_send_driver_email = 'Siųsti vairuotojo el. laišką';
_fc_props.directions_not_found = 'Neteisingas {0} adresas. Nuorodos nerastos.';
_fc_props.ws_user = 'Vartotojas';
_fc_props.ws_service = 'Paslauga';
_fc_props.ws_method = 'Metodas';
_fc_props.ws_params = 'Parametrai';
_fc_props.units_kilometers_abbr = 'KM';
_fc_props.units_miles_abbr = 'MI';
_fc_props.origin_and_destination = 'Kilmės ir paskirties vieta';
_fc_props.liter_abbr = 'l';
_fc_props.help = 'Pagalba';
_fc_props.settings.command_mobile_ticket_use_alt_emp_number = '„Android“ naudokite alternatyvų darbuotojo numerį';
_fc_props.settings.command_mobile_ticket_android_url = '„Android“ mobiliojo bilieto URL';
_fc_props.settings.command_mobile_ticket_android_secret = '„Android“ mobiliojo bilieto paslaptis';
_fc_props.employee_x_has_no_logout_on_y = 'Darbuotojas {0} neturi atsijungimo nuo pamainos, prasidedančios {1}.';
_fc_props.phone_number_has_duplicates = 'Telefonų numeriuose yra pasikartojančių įrašų';
_fc_props.ounce = 'Uncija';
_fc_props.water_extra = 'Papildomas vanduo';
_fc_props.always = 'Visada';
_fc_props.work_types_must_be_unique = 'Darbo tipai turi būti unikalūs';
_fc_props.manufacturer = 'Gamintojas';
_fc_props.need_to_enter_seconds = 'Reikia įvesti sekundes.';
_fc_props.copy = 'Kopijuoti';
_fc_props.create_in_existing_required = 'Norint sukurti tarptinklinio ryšio interneto prieigos tašką, turi būti pasirinkta „Sukurti esamame“.';
_fc_props.break = 'Pertrauka';
_fc_props.add_export_data_type = 'Pridėti eksportuojamų duomenų tipą';
_fc_props.edit_export_data_type = 'Redaguoti eksportuojamų duomenų tipą';
_fc_props.delete_export_data_type = 'Ištrinti eksportuojamų duomenų tipą';
_fc_props.export_data_type = 'Eksportuoti duomenų tipą';
_fc_props.error_updating_export_data_type = 'Klaida atnaujinant eksportuojamų duomenų tipą';
_fc_props.settings.address_key = 'Adreso raktas';
_fc_props.settings.address_key_hover = 'Adreso rakto parinktys';
_fc_props.settings.address_key_options = 'Adreso rakto parinktys';
_fc_props.more_filter_options = 'Daugiau filtro parinkčių';
_fc_props.unauthorized_mapit_app = 'Ši „MapIt“ versija nėra autorizuota, prašome kuo greičiau atnaujinti „MapIt“.';
_fc_props.zello_timeout = 'Susisiekiant su Zello, baigėsi laikas.';
_fc_props.user_agreement_text = 'Prisijungdami jūs sutinkate su';
_fc_props.user_agreement = 'vartotojo sutartis';
_fc_props.upload = 'Įkelti';
_fc_props.x_mins_left = 'Liko {0} min.';
_fc_props.continuous_location_tracking_colon = 'Nuolatinis vietos sekimas:';
_fc_props.hired_hauler_cannot_register_device = 'Samdomas vežėjas negali užregistruoti naujo įrenginio.';
_fc_props.timecard_does_not_contain_shift = 'Darbuotojo laiko kortelėje nėra nurodytos pamainos (laiko kortelės informacijos).';
_fc_props.timecard_not_found = 'Darbuotojo laiko kortelė nerasta';
_fc_props.vehicle_must_be_assigned_for_clt = 'Transporto priemonė turi būti priskirta trasos vietoms.';
_fc_props.vehicle_unassigned_continuous_tracking_disabled = 'Transporto priemonei nebuvo priskirtas nuolatinis sekimas, todėl ji bus išjungta.';
_fc_props.units_yards_abbr = 'YD';
_fc_props.units_meters_abbr = 'M.';
_fc_props.error_lost_edc_connection = 'Nutrūko ryšys su telematikos įrenginiu. Patikrinkite, ar įjungtas „Wi-Fi“ ir (arba) „Bluetooth“ ryšys.';
_fc_props.acknowledge_all = 'Patvirtinti visus';
_fc_props.expand = 'Išskleisti';
_fc_props.collapse = 'Sutraukti';
_fc_props.expand_all = 'Išskleisti viską';
_fc_props.collapse_all = 'Sutraukti viską';
_fc_props.last_update = 'Paskutinis atnaujinimas';
_fc_props.acknowledge_alert = 'Patvirtinti įspėjimą';
_fc_props.acknowledge_message = 'Patvirtinti pranešimą';
_fc_props.acknowledge_all_alerts = 'Patvirtinti visus įspėjimus';
_fc_props.acknowledge_all_messages = 'Patvirtinti visus pranešimus';
_fc_props.eta = 'Numatomas laikas';
_fc_props.tolerance_must_be_a_valid_integer = 'Tolerancijos vertė turi būti galiojantis sveikasis skaičius nuo -99 iki 99 (abu imtinai)';
_fc_props.gps_permission_required = 'Reikalingas GPS leidimas';
_fc_props.permissions_required = 'Reikalingi leidimai';
_fc_props.change_user = 'Keisti vartotoją';
_fc_props.account_not_registered_with_carrier = 'Ši paskyra nėra registruota pas operatorių';
_fc_props.slump_loss = 'Nuosmukio nuostolis';
_fc_props.slump_loss_help = 'Pagalba dėl nuosmukio nuostolių';
_fc_props.did_not_receive_any_edc_devices = 'Negavo jokių įrenginių.';
_fc_props.edc_record_not_found = 'Telematinio įrenginio įrašas nerastas';
_fc_props.disable_hotspot_prompt = 'Kai būsite paraginti išjungti interneto prieigos tašką, palieskite „Gerai“.';
_fc_props.edc_device_is_in_use = 'Telematinis įrenginys {0} yra naudojamas.';
_fc_props.an_unknown_exception_has_occurred = 'Įvyko nežinoma išimtis';
_fc_props.login_has_timed_out = 'Prisijungimo laikas baigėsi';
_fc_props.use_paper_logs = 'Naudokite popierinius žurnalus';
_fc_props.eld_login_failed = 'Nepavyko prisijungti prie darbo valandų';
_fc_props.setup_time_off_type = 'Nustatykite laisvo laiko tipą.';
_fc_props.view_load_properties = 'Peržiūrėti įkėlimo ypatybes';
_fc_props.couldnt_download_edc_firmware = 'Nepavyko atsisiųsti telematinio įrenginio programinės įrangos.';
_fc_props.password_incorrect = 'Slaptažodis neteisingas';
_fc_props.edc_configuration_password_prompt = 'Dėl šio įrenginio būsenos konfigūruojant reikia įvesti montuotojo slaptažodį.';
_fc_props.edc_configuration_check_failed = 'Telematinio įrenginio serverio įrašų patvirtinimas nepavyko. Išsamesnės informacijos ieškokite klaidų pranešimuose.';
_fc_props.configuration_issues_prompt = 'Konfigūruojant pasirinktą telematikos įrenginį nurodytam sunkvežimiui, aptiktos šios problemos';
_fc_props.checking_password = 'Tikrinamas slaptažodis';
_fc_props.reset_password_instructions_sent = 'Instrukcijos, kaip atkurti slaptažodį, išsiųstos el. pašto adresu {0}.';
_fc_props.reset_password_failed = 'Nepavyko atkurti slaptažodžio, bandykite dar kartą.';
_fc_props.forgot_password = 'Pamiršote slaptažodį?';
_fc_props.enter_valid_email = 'Neteisingas el. pašto adresas, įveskite galiojantį el. pašto adresą ir bandykite dar kartą.';
_fc_props.issues_while_updating_edc_record = 'Telematinis įrenginys sėkmingai sukonfigūruotas. Tačiau yra problemų su įrenginio įrašais „TrackIt“ serveryje, dėl kurių jis gali neveikti. Norėdami ištaisyti informaciją, susisiekite su palaikymo tarnyba.';
_fc_props.sending = 'Siunčiama...';
_fc_props.minimum_ratio = 'Minimalus santykis';
_fc_props.vin = 'VIN';
_fc_props.probe_rpm_not_in_range = 'Būgno apsukų skaičius ne diapazone';
_fc_props.probe_failure = 'Zondo gedimas';
_fc_props.unknown_probe_data_failure = 'Nežinoma zondo duomenų klaida';
_fc_props.no_loaded_status_meaning = 'Nėra įkeltos būsenos';
_fc_props.no_depart_status_meaning = 'Nėra išvykimo būsenos';
_fc_props.no_arrive_status_meaning = 'Nėra atvykimo būsenos';
_fc_props.no_begin_work_status_meaning = 'Nepradėtas darbo statusas';
_fc_props.no_fully_mixed_status_meaning = 'Nėra visiškai mišraus statuso';
_fc_props.no_begin_work_or_at_job_status = 'Nėra būsenų „Pradėti darbą“ arba „Darbo vietoje“';
_fc_props.driver_didnt_follow_procedure = 'Vairuotojas nesilaikė procedūros (nesulėtino greičio būgno)';
_fc_props.probe_malfunction = 'Zondo gedimas (vidinis gedimas ir kt.)';
_fc_props.no_data_from_probe = 'Nėra duomenų iš zondo (duomenų praradimas)';
_fc_props.missing_probe_calibration = 'Nėra zondo kalibravimo duomenų';
_fc_props.probe_pressure_not_in_range = 'Zondo slėgis nepatenka į diapazoną';
_fc_props.arrival = 'Atvykimas';
_fc_props.small_load = 'MAŽAS APKROVIMAS';
_fc_props.dry_slump = 'SAUSAS NUOSMULIS';
_fc_props.probe_remixing_turns = 'Remiksavimas';
_fc_props.turns_needed_to_remix = 'Įpilta vandens – reikia papildomai maišyti';
_fc_props.probe_remixing_finished = 'Remiksas baigtas';
_fc_props.probe_battery_low_alert = 'Įspėjimas apie išsikrovusį zondo akumuliatorių';
_fc_props.probe_battery_low_message = 'Zondo baterija išsikrovusi';
_fc_props.probe_battery_low = 'Zondo baterija išsikrovusi';
_fc_props.alert_when_probe_battery_low = 'Įspėjimas, kai zondo baterija išsikrauna';
_fc_props.probe_sensor_fatal_failure = 'Jutiklio mirtinas gedimas';
_fc_props.probe_thermistor_failure = 'Termistoriaus gedimas';
_fc_props.probe_sensor_stuck_in_concrete = 'Jutiklis įstrigo betone';
_fc_props.probe_sensor_over_weight = 'Jutiklis per didelis svoris';
_fc_props.probe_batteries_low = 'Baterija išsikrovė';
_fc_props.no_probe_data = 'Nėra zondo duomenų:';
_fc_props.check_probe = 'Patikrinkite zondą';
_fc_props.service_probe = 'Aptarnavimo zondas';
_fc_props.below_x = 'Žemiau {0}';
_fc_props.above_x = 'Virš {0}';
_fc_props.probe_serial_number_invalid_format = 'Zondo serijos numeris nurodytas netinkamu formatu, kaip rodomas lauko vietos rezervavimo ženkle.';
_fc_props.talk_dnd_permission_prompt = 'Pokalbiui reikalingas leidimas NETRUKDYTI.';
_fc_props.max = 'Maks.';
_fc_props.status_changed_quickly = 'Statusas pasikeitė per greitai';
_fc_props.is_empty = 'Tuščia';
_fc_props.slump_increased_plasticizer_question = 'Ar buvo pridėtas plastifikatorius?';
_fc_props.slump_increased_water_added_question = 'Kiek nematuoto vandens buvo įpilta?';
_fc_props.probe_and_drs_are_not_support_together_on_the_same_device = 'Zondo ir tiekimo ciklo stebėjimo funkcijos tame pačiame įrenginyje nepalaikomos kartu.';
_fc_props.no_data_from_sensor = 'Nėra duomenų iš jutiklio (duomenų praradimas)';
_fc_props.dvir = 'DVIR';
_fc_props.system_type = 'Sistemos tipas';
_fc_props.magnet_count = 'Magnetų skaičius';
_fc_props.sensors_setup = 'Jutiklių sąranka';
_fc_props.drs_requires_io_mac_sensor_drum_type_magnet_count = 'DCM reikia nustatyti įvesties/išvesties dėžutės MAC adresą, būgno tipą, DCM tipą ir magnetų skaičių.';
_fc_props.drs = 'DCM';
_fc_props.drs_ticketed_volume = 'Registruotas kiekis';
_fc_props.drs_current_volume = 'Dabartinis garsumas';
_fc_props.drs_current_water_cement_ratio = 'Dabartinis vandens ir cemento santykis';
_fc_props.drs_target_water_cement_ratio = 'Tikslinis vandens ir cemento santykis';
_fc_props.drs_total_revolutions = 'Iš viso';
_fc_props.drs_current_volume_lp_small = 'Dabartinis';
_fc_props.drum_revolutions = 'Būgnų revoliucijos';
_fc_props.drs_total_revolutions_lp_small = 'Iš viso';
_fc_props.drs_charging_revolutions_lp_small = 'Įkrovimas';
_fc_props.drs_discharging_revolutions_lp_small = 'Iškrovimas';
_fc_props.drs_target_wc_lp_small = 'Tikslinė savaitė';
_fc_props.drs_current_wc_lp_small = 'Dabartinis savaitės režimas';
_fc_props.drs_ticketed_volume_lp_small = 'Bilietas';
_fc_props.android_location_disclosure = '„TrackIt“ naudoja tikslius ir apytikslius vietos duomenis, kad fone rinktų vietos duomenis, net kai sistema nenaudojama, ir taip įgalintų automatinį būsenos nustatymą bei realaus laiko žemėlapio matomumą dispečeriams.';
_fc_props.android_location_usage = 'Vietos atskleidimas';
_fc_props.end_pour_trigger_threshold = 'Išpylimo pabaigos suveikimo slenkstis';
_fc_props.drs_wiring_error = 'Laidų klaida';
_fc_props.drs_wiring_pulse_error = 'Laidų impulsų klaida';
_fc_props.drs_wiring_magnet_error = 'Laidų magneto klaida';
_fc_props.drs_magnet_missing_error = 'Magneto trūkumo klaida';
_fc_props.android_location_disclosure_3p = '„TrackIt“ fone renka vietos duomenis, kad būtų galima automatiškai nustatyti siuntos būseną ir matyti žemėlapį realiuoju laiku. Kai siuntėjas siunčia duomenis iš siuntos, vieta nebendrinama.';
_fc_props.please_select_either_fullmdm_or_trackit_remote_support = 'Pasirinkite „Full MDM“ arba „Trackit“ nuotolinę pagalbą';
_fc_props.move_up = 'Perkelti aukštyn';
_fc_props.move_down = 'Perkelti žemyn';
_fc_props.driver_not_found = 'Vairuotojas nerastas.';
_fc_props.multiple = 'Keli';
_fc_props.water_meter_installed = 'Vandens skaitiklis sumontuotas';
_fc_props.delete_waypoint = 'Ištrinti kelio tašką';
_fc_props.wash_sensor_installed = 'Įrengtas plovimo jutiklis';
_fc_props.washing_start_time = 'Skalbimo pradžios laikas';
_fc_props.end_washing = 'Skalbimo pabaiga';
_fc_props.variable_rpms = 'Kintamųjų RPM';
_fc_props.no_slump = 'Nėra nuosmukio';
_fc_props.end_washing_duration = 'Skalbimo pabaigos trukmė';
_fc_props.privacy_policy = 'Privatumo politika';
_fc_props.privacy_policy_text = 'Perskaičiau ir sutinku su';
_fc_props.login_fail_accept_privacy_policy = 'Norint tęsti, reikia sutikti su privatumo politika.';
_fc_props.rotation_sensor = 'Sukimosi jutiklis';
_fc_props.pto_sensor = 'PTO jutiklis';
_fc_props.pto_sensor_installed = 'PTO jutiklis sumontuotas';
_fc_props.polarity_reversed = 'Atvirkštinis poliškumas';
_fc_props.pto_sensor_type = 'PTO jutiklio tipas';
_fc_props.sensor_type = 'Jutiklio tipas';
_fc_props.prompt_select_pto_sensor_type = 'Jei kaip pagrindinį jutiklio tipą pasirinkote „Gauto veleno jutiklį“, turite pasirinkti „Gauto veleno jutiklio tipą“.';
_fc_props.priming_turns_at_full_load = 'Įpurškimas įjungiamas esant pilnai apkrovai';
_fc_props.priming_turns_at_ten_percent_load = 'Užpildymo posūkiai esant 10 % apkrovai';
_fc_props.weight_units = 'Svorio vienetai';
_fc_props.settings.send_status = 'Siųsti būseną / vietą į renginių tiltą';
_fc_props.volume_difference = 'Tūrio skirtumas';
_fc_props.mobile_ticket_iframe_url = 'Mobiliojo bilieto IFrame URL';
_fc_props.mobile_ticket_user = 'Mobiliojo bilieto naudotojas';
_fc_props.mobile_ticket_password = 'Mobiliojo bilieto slaptažodis';
_fc_props.current_truck_status = 'Dabartinė sunkvežimio būsena';
_fc_props.estimated_symbol = '℮';
_fc_props.almost_equal_to_symbol = '≈';
_fc_props.triggered_by_max_revolutions = 'Suveikia maksimalūs apsisukimai';
_fc_props.alerts_by_type = 'Įspėjimai pagal tipą';
_fc_props.water_flow_meter = 'Vandens srauto matuoklis';
_fc_props.flow_meter_no_pulses_warning = 'Nėra impulsų – įspėjimas';
_fc_props.flow_meter_no_pulses_critical = 'Nėra impulsų – kritinis';
_fc_props.flow_meter_excessive_pulses = 'Pernelyg dideli impulsai';
_fc_props.flow_meter_constantly_flowing = 'Nuolat tekantis';
_fc_props.flow_meter_good = 'Gerai';
_fc_props.whats_new = 'Kas naujo';
_fc_props.whats_new_widget_text = 'Ar žinojote, kad „TrackIt“ atnaujiname bent kartą per mėnesį? Gaukite naujausius atnaujinimus ir patarimus.';
_fc_props.get_the_scoop = 'Gaukite informaciją';
_fc_props.trackit_insights = '„Trackit“ įžvalgos';
_fc_props.business_analytics_blurb = 'Verslo analizė, kuri pagerina jūsų pelną, dabar įtraukta į „TrackIt“';
_fc_props.find_out_more = 'Sužinokite daugiau';
_fc_props.daily_breakdown = 'Dienos suskirstymas';
_fc_props.question_summary = 'Klausimo santrauka';
_fc_props.trip_summary = 'Kelionės santrauka';
_fc_props.manage_employees = 'Tvarkyti darbuotojus';
_fc_props.manage_hotspots = 'Tvarkyti karštąsias zonas';
_fc_props.manage_devices = 'Tvarkyti įrenginius';
_fc_props.manage_equipment = 'Įrangos valdymas';
_fc_props.manage_users = 'Tvarkyti naudotojus';
_fc_props.manage_statuses = 'Tvarkyti būsenas';
_fc_props.manage_alerts = 'Tvarkyti įspėjimus';
_fc_props.popular_report_links = 'Populiarios ataskaitų nuorodos';
_fc_props.popular_settings_links = 'Populiarių nustatymų nuorodos';
_fc_props.sidemenu_settings = 'Nustatymai';
_fc_props.loads_per_driver = 'Krovinių skaičius vienam vairuotojui';
_fc_props.please_select_application = 'Pasirinkite bent vieną programą';
_fc_props.external_app_processing = 'Apdorojama išorinėje programoje';
_fc_props.external_app_sent = 'Išsiųsta į išorinę programą';
_fc_props.external_app_received = 'Gauta iš išorinės programos';
_fc_props.wait_time_at_job = 'Laukimo laikas darbe';
_fc_props.wait_time_at_plant = 'Laukimo laikas gamykloje';
_fc_props.loading_time = 'Pakrovimo laikas';
_fc_props.unloading_time = 'Iškrovimo laikas';
_fc_props.pre_post_trip = 'Prieš kelionę / po kelionės';
_fc_props.update_thresholds = 'Atnaujinimo slenksčiai';
_fc_props.green = 'Žalia';
_fc_props.yellow = 'Geltona';
_fc_props.red = 'Raudona';
_fc_props.between = 'Tarp';
_fc_props.num_of_loads = 'Krovinių skaičius';
_fc_props.num_of_drivers = 'Vairuotojų skaičius';
_fc_props.status_meaning_not_setup = 'Būsena Reikšmė Nenustatyta';
_fc_props.or_less = 'Arba mažiau';
_fc_props.or_greater = 'Arba didesnis';
_fc_props.probe_self_diagnostic_state = 'Zondo savidiagnostikos būsena';
_fc_props.update_current_truck_status_settings = 'Atnaujinti dabartinius sunkvežimio būsenos nustatymus';
_fc_props.default_behavior = 'Numatytoji (10 populiariausių būsenų)';
_fc_props.combine_similar_statuses = 'Sujungti tas pačias būsenas iš visų tipų (ciklai)';
_fc_props.use_other_category = 'Naudoti kategoriją „Kita“';
_fc_props.selected_statuses = 'Pasirinktos būsenos';
_fc_props.ideas = 'Idėjos';
_fc_props.air_content = 'Oro kiekis';
_fc_props.air_measured_time = 'Oro išmatuotas laikas';
_fc_props.ten_max = '10 maks.';
_fc_props.loads_per_plant = 'Apkrovos vienam augalui';
_fc_props.invalid_flow_meter_pulse_per_volume = 'Neteisingas srauto matuoklio impulsų skaičius tūriui.';
_fc_props.coming_soon_title = 'Daugiau valdiklių netrukus';
_fc_props.submit_your_ideas = 'Pateikite savo idėjas mūsų idėjų portalui naudodami lemputės piktogramą kairiajame naršymo meniu.';
_fc_props.selected_plants = 'Pasirinkti augalai';
_fc_props.update_loads_per_plant_settings = 'Atnaujinti apkrovų nustatymus pagal gamyklą';
_fc_props.default_top_10_plants = 'Numatytasis (10 geriausių augalų)';
_fc_props.phone_number_will_be_uploaded = 'Įrenginio ID bus įkeltas registracijos tikslais.';
_fc_props.include_deleted = 'Įtraukti ištrintus';
_fc_props.primary_status_type = 'Pirminis būsenos tipas';
_fc_props.additional_status_trigger = 'Papildomi būsenos suaktyvintojai';
_fc_props.update_tickets_destination = 'Atnaujinti paskirties vietą visuose susijusiuose bilietuose';
_fc_props.settings.send_destination_changes_to_connex = 'Siųsti paskirties vietos pakeitimus į „Connex“';
_fc_props.settings.is_the_ticket_active_when_it_is_received_by_trackit_default_always = 'Ar bilietas aktyvus, kai jį gauna „TrackIt“ (numatytoji reikšmė „visada“)';
_fc_props.settings.autoactivate_next_ticket_on_ticket_completion = 'Automatiškai aktyvuoti kitą užklausą užpildžius ankstesnę';
_fc_props.settings.should_autoactivate_next_ticket_on_ticket_completion_default_true = 'Turėtų automatiškai aktyvuoti kitą užklausą užbaigus užklausą (numatytoji reikšmė „true“)';
_fc_props.settings.status_to_idle_status_when_no_active_ticket = 'Būsena į neveiklumo būseną, kai nėra aktyvių bilietų';
_fc_props.break_down = 'Suskirstyti';
_fc_props.idle = 'Neveikimo režimas';
_fc_props.pto_work_maximum_speed_limit = 'Didžiausias darbo greičio apribojimas';
_fc_props.settings.associate_ticket_to_status_on_complete = 'Susieto statuso pakeitimas, kuris užbaigia užklausą su ta užklausa';
_fc_props.approaching = 'Artėja';
_fc_props.performing_task = 'Atliekama užduotis';
_fc_props.are_you_sure_you_want_to_delete_geogate = 'Ar tikrai norite ištrinti „Geogate {0}“?';
_fc_props.trackit_destination_changed_to_0 = 'Atnaujinti bilietą {0}. Pakeista paskirties vieta.';
_fc_props.trackit_return_destination_changed_to_0 = 'Atnaujinti bilietą {0}. Grąžinimas pakeistas.';
_fc_props.menu_settings_title_geogate = 'Geografiniai vartai';
_fc_props.add_geogate = 'Pridėti geografinius vartus';
_fc_props.driver_enabled = 'Vairuotojas įjungtas';
_fc_props.dispatcher_enabled = 'Dispečeris įjungtas';
_fc_props.runsheet_number = 'Sąrašo numeris';
_fc_props.manual_load = 'Rankinis krovimas';
_fc_props.delivery = 'Pristatymas';
_fc_props.return_run = 'Grįžimo bėgimas';
_fc_props.home_run = 'Namų bėgimas';
_fc_props.edit_geogate = 'Redaguoti geografinius vartus';
_fc_props.handling = 'Tvarkymas';
_fc_props.geogate_name = 'Geografiniai vartai';
_fc_props.geogate_panel = 'Geografinių vartų skydas';
_fc_props.vehicle_is_not_logged_in = 'Žinutė neišsiųsta (transporto priemonė neprisijungusi)';
_fc_props.air = 'Oras';
_fc_props.create_a_geogate = 'Sukurkite geovartus';
_fc_props.click_the_map_to_set_the_geogate_points = 'Spustelėkite žemėlapį, kad nustatytumėte geovartų taškus.';
_fc_props.clock_out = 'Išėjimo laikas';
_fc_props.handling_operation = 'Tvarkymo operacija';
_fc_props.view_geogates = 'Peržiūrėti geogatus';
_fc_props.select_a_geogate = 'Pasirinkite geografinius vartus';
_fc_props.failed_to_find_geogate = 'Nepavyko rasti „Geogate“';
_fc_props.adjust_geogate = 'Koreguoti geografinius vartus';
_fc_props.geogate_expiration_date_time_extra_days = '„Geogate“ galiojimo pabaigos data Laikas Numatytasis Papildomos dienos';
_fc_props.menu_settings_title_retention = 'Duomenų saugojimas';
_fc_props.category = 'Kategorija';
_fc_props.telemetry = 'Telemetrija';
_fc_props.ticket_data = 'Bilietų duomenys';
_fc_props.driver_break = 'Vairuotojo pertrauka';
_fc_props._30_days = '30 dienų';
_fc_props._6_months = '6 mėnesiai';
_fc_props._1_year = '1 metai';
_fc_props._3_years = '3 metai';
_fc_props.discharge = 'Išleidimas';
_fc_props.new_group = 'Nauja grupė';
_fc_props.selected_vehicles = 'Pasirinktos transporto priemonės';
_fc_props.group_name_is_required_field = 'Grupės pavadinimo laukas yra privalomas';
_fc_props.at_least_vehicle_should_be_selected = 'Reikia pasirinkti bent 1 transporto priemonę';
_fc_props.groups = 'Grupės';
_fc_props.trucks = 'Sunkvežimiai';
_fc_props.geogate_has_been_removed_please_refresh_page = 'Geografiniai vartai pašalinti. Atnaujinkite puslapį.';
_fc_props.air_timestamp = 'Oro laiko žyma';
_fc_props.fail = 'NESĖKMĖ';
_fc_props.stuck = 'ĮSTRIBOJĘS';
_fc_props.dirty = 'NEŠVARUS';
_fc_props.driver_breakdown = 'Suskaidymas';
_fc_props.seasonal = 'Sezoninis';
_fc_props.category_details = 'Kategorijos informacija';
_fc_props.alert_events = 'Įspėjimų įvykiai';
_fc_props.driver_performance_infractions = 'Vairuotojo veiklos pažeidimai';
_fc_props.telemetry_details = 'Vietos duomenys, karštieji taškai, laikas karštuosiuose taškuose, laikas regionuose, DCM duomenys, zondo duomenys, variklio duomenys';
_fc_props.ticket_data_details = 'Bilietų duomenys';
_fc_props.general_details = 'Statuso pakeitimai, laiko kortelės, tvarkaraščiai';
_fc_props.wash = 'Plovimas';
_fc_props.filter_options = 'Filtro parinktys';
_fc_props.home_plants = 'Naminiai augalai';
_fc_props.delivery_multidrop = 'Daugialypis pristatymas';
_fc_props.dcm = 'DCM';
_fc_props.pto_requires_pto_sensor_type_value = 'DCM PTO reikia nustatyti PTO jutiklio tipą.';
_fc_props.invalid_io_box_mac_address = 'Neteisingas įvesties/išvesties dėžutės „Mac“ adresas';
_fc_props.access_denied = 'Prieiga uždrausta';
_fc_props.wash_events = 'Plovimo renginiai';
_fc_props.min_speed = 'Minimalus greitis';
_fc_props.temperature_change = 'Temperatūros pokytis';
_fc_props.degrees_cap = 'Laipsniai';
_fc_props.washout_tracking = 'Išplovimo sekimas';
_fc_props.approaching_wash = 'Artėja Plovimas';
_fc_props.arrival_wash = 'Atvykimo skalbimas';
_fc_props.performing_wash = 'Atliekamas plovimas';
_fc_props.wash_complete = 'Skalbimas baigtas';
_fc_props.must_be_positive_or_zero = 'Turi būti teigiamas arba nulis!';
_fc_props.min_speed_greater_than_max = 'Minimalus greitis turi būti mažesnis nei maksimalus!';
_fc_props.clock_in = 'Registracija';
_fc_props.mix_water_at_x_to_y_for_t = 'Maišykite vandenį {0}–{1} aps./min. greičiu {2} apsisukimų.';
_fc_props.discharge_water_for_x_revolutions = 'Išleiskite vandenį {0} apsisukimams.';
_fc_props.eod_drum_wash_complete = 'Būgno plovimas baigtas! <br> Sustabdykite būgną, zondą nukreipę į viršų.';
_fc_props.washing_complete = 'Valdomas plovimas baigtas';
_fc_props.eod_washout_no_data_available = 'Jutiklio duomenys nepasiekiami, prašome užbaikite plovimo procesą.';
_fc_props.eod_washout_no_data_available_title = 'Valdomas išplovimas negalimas';
_fc_props.menu_reports_title_ticket_time_summary = 'Bilieto laiko suvestinė';
_fc_props.menu_reports_description_ticket_time_summary = 'Peržiūrėti užsakymo arba transporto priemonės bilieto laiko informaciją';
_fc_props.menu_reports_title_summary = 'Santrauka';
_fc_props.menu_reports_title_ticket_summary = 'Kvito suvestinė';
_fc_props.menu_reports_description_summary1 = 'Peržiūrėti laiko santrauką viešosiose vietose';
_fc_props.menu_dispatch_title_main = 'Pagrindinis';
_fc_props.menu_dispatch_title_login_registry = 'Prisijungimo registras';
_fc_props.menu_reports_title_main = 'Pagrindinis';
_fc_props.time_management_are_you_sure_you_want_to_delete_export_data_type = 'Ar tikrai norite ištrinti šį eksportuojamų duomenų tipą?';
_fc_props.dvir_status_paper_logs = 'Popieriniai žurnalai';
_fc_props.menu_reports_title_billing_report = 'Atsiskaitymo ataskaita';
_fc_props.menu_reports_description_billing_report = 'Atsiskaitymo ataskaita';
_fc_props.settings_status_to_ticketed_status_on_activate_work = 'Būsena iki bilieto būsenos aktyvuojant darbą';
_fc_props.settings_status_to_ticketed_status_on_activate_work_default_false = 'Būsena iki bilieto būsenos aktyvuojant darbą (numatytoji reikšmė „False“)';
_fc_props.status_change_type_drum_rotation_sensor = 'DCM';
_fc_props.settings_connex_eid = '„Connex“ EID';
_fc_props.units_weight_pound_label = 'Svarai';
_fc_props.units_weight_kilogram_label = 'Kilogramai';
_fc_props.settings_weight = 'Svoris';
_fc_props.units_pounds = 'Svarai';
_fc_props.units_kilograms = 'Kilogramai';
_fc_props.geo_gate_edit_modal_description = 'Aprašymas';
_fc_props.geo_gate_edit_modal_start_point = 'Pradžios taškas';
_fc_props.geo_gate_edit_modal_end_point = 'Pabaigos taškas';
_fc_props.geo_gate_edit_modal_vehicle_types = 'Įrangos tipas';
_fc_props.geo_gate_edit_modal_heading_south = 'Pietų į šiaurę';
_fc_props.geo_gate_edit_modal_heading_north = 'Šiaurės–pietų';
_fc_props.geo_gate_edit_modal_driver_message = 'Vairuotojo pranešimas';
_fc_props.geo_gate_edit_modal_dispatcher_message = 'Išsiuntimo pranešimas';
_fc_props.geo_gate_edit_modal_expiration_date_time = 'Galiojimo data ir laikas';
_fc_props.geo_gate_edit_modal_permanent = 'Nuolatinis';
_fc_props.geo_gate_edit_modal_critical = 'Kritinis';
_fc_props.geo_gate_edit_modal_error_message_description_empty = 'Klaida išsaugant geografinius vartus: aprašymo laukas turi būti užpildytas.';
_fc_props.geo_gate_edit_modal_error_message_start_point_empty = 'Klaida išsaugant geografinius vartus: pradžios taško laukas turi būti užpildytas.';
_fc_props.geo_gate_edit_modal_error_message_start_point_invalid_format = 'Klaida išsaugant geografinius vartus: pradžios taško lauke yra neteisingas duomenų formatas.';
_fc_props.geo_gate_edit_modal_error_message_end_point_invalid_format = 'Klaida išsaugant geografinius vartus: galinio taško lauke yra neteisingas duomenų formatas.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_empty = 'Klaida išsaugant geografinius vartus: turi būti užpildytas galiojimo pabaigos datos ir laiko laukas.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_invalid_format = 'Klaida išsaugant „Geogate“: galiojimo datos ir laiko lauke yra neteisingas duomenų formatas.';
_fc_props.geo_gate_edit_modal_error_message_heading_north_dispatcher_message_empty = 'Klaida išsaugant geografinius vartus: šiaurės–pietų – išsiuntimo pranešimo laukas turi būti užpildytas';
_fc_props.geo_gate_edit_modal_error_message_no_changes = 'Klaida išsaugant „Geogate“: neaptikta jokių pakeitimų';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_expired = 'Klaida išsaugant „Geogate“: galiojimo pabaigos datos ir laiko lauke yra pasibaigusio galiojimo data ir laikas.';
_fc_props.geo_gate_edit_modal_error_message_description_invalid_format = 'Klaida išsaugant geografinius vartus: aprašymo lauke gali būti tik raidės ir skaičiai';
_fc_props.geo_gate_edit_modal_error_message_vehicle_types_empty = 'Klaida išsaugant „Geogate“: Įrangos tipo laukas turi būti užpildytas';
_fc_props.geo_gate_table_message_label_north_to_south = 'Šiaurės–pietų';
_fc_props.geo_gate_table_message_label_south_to_north = 'Pietų į šiaurę';
_fc_props.geo_gate_table_message_label_both = 'Abu';
_fc_props.geo_gate_edit_modal_field_point_tip = 'Platuma, ilguma';
_fc_props.geo_gate_edit_modal_device_movement_message_restriction = 'Pažymėjus šį nustatymą, bus panaikintas įrenginio judėjimo pranešimų apribojimo nustatymas.';
_fc_props.geo_gate_edit_modal_seasonal = 'Sezoninis';
_fc_props.geo_gate_edit_modal_error_message_seasonal_empty = 'Klaida išsaugant „Geogate“: sezoninės datos turi būti užpildytos';
_fc_props.geo_gate_edit_modal_error_message_seasonal_invalid_date_format = 'Klaida išsaugant „Geogate“: sezoninių datų laukuose yra neteisingas duomenų formatas';
_fc_props.test_js_test_javascript = 'Išbandykite „Javascript“';
_fc_props.units_miles_per_hour_abbr = 'Mylia per valandą';
_fc_props.units_kilometers_per_hour_abbr = 'KM/h';
_fc_props.units_kilometers = 'Kilometrai';
_fc_props.units_miles = 'Mylios';
_fc_props.units_gallons_abbr = 'GAL';
_fc_props.units_liters_abbr = 'L';
_fc_props.geo_gate_edit_modal_error_message_heading_south_driver_message_empty = 'Klaida išsaugant geografinius vartus: iš pietų į šiaurę – vairuotojo pranešimo laukas turi būti užpildytas';
_fc_props.geo_gate_edit_modal_error_message_heading_south_dispatcher_message_empty = 'Klaida išsaugant geografinius vartus: iš pietų į šiaurę – išsiuntimo pranešimo laukas turi būti užpildytas';
_fc_props.geo_gate_edit_modal_error_message_heading_north_driver_message_empty = 'Klaida išsaugant geografinius vartus: šiaurės–pietų – vairuotojo pranešimo laukas turi būti užpildytas';
_fc_props.geo_gate_heading = 'Antraštė';
_fc_props.geo_gate_edit_modal_error_message_end_point_empty = 'Klaida išsaugant geografinius vartus: turi būti užpildytas galinio taško laukas';
_fc_props.units_mile = 'Mylia';
_fc_props.units_kilometer = 'Kilometras';
_fc_props.cloud_dvir__exit = 'Išeiti';
_fc_props.cloud_dvir__signature = 'Parašas';
_fc_props.cloud_dvir__inspection = 'Apžiūra';
_fc_props.cloud_dvir__add_photos_notes = 'Pridėti nuotraukų / pastabų';
_fc_props.cloud_dvir__odometer_reading = 'Odometro rodmenys';
_fc_props.cloud_dvir__engine_hours = 'Variklio valandos';
_fc_props.cloud_dvir__truck_details = 'Sunkvežimio detalės';
_fc_props.cloud_dvir__determine_the_overall_condition_of_the_vehicle = 'Nustatykite bendrą transporto priemonės būklę';
_fc_props.cloud_dvir__full_name_and_signature_of_driver = 'Vairuotojo vardas, pavardė ir parašas';
_fc_props.cloud_dvir__sign = 'Ženklas';
_fc_props.cloud_dvir__driver_note_from = 'Vairuotojo pastaba iš';
_fc_props.cloud_dvir__add_notes = 'Pridėti pastabas';
_fc_props.cloud_dvir__driver_notes = 'Vairuotojo pastabos';
_fc_props.cloud_dvir__done = 'Atlikta';
_fc_props.cloud_dvir__needs_repair = 'Reikia remonto';
_fc_props.cloud_dvir__not_applicable = 'Netaikoma';
_fc_props.cloud_dvir__review_and_sign = 'Peržiūrėti ir pasirašyti';
_fc_props.cloud_dvir__add_photos = 'Pridėti nuotrauką';
_fc_props.cloud_dvir__upload_photo_limit = 'Galite įkelti iki 3 nuotraukų';
_fc_props.cloud_dvir__mismatch_title = 'Neatitikimo įspėjimas';
_fc_props.cloud_dvir__ok = 'Gerai';
_fc_props.cloud_dvir_template = 'Debesijos DVIR šablonas';
_fc_props.cloud_dvir__needs_review = 'DVIR poreikių peržiūra';
_fc_props.cloud_dvir__submitted = 'Pateikta';
_fc_props.cloud_dvir__completed_by = 'Užbaigė';
_fc_props.cloud_dvir__review_btn = 'RevIew';
_fc_props.cloud_dvir__truck_number = 'Sunkvežimis {0}';
_fc_props.cloud_dvir__pending_review = 'Laukiama peržiūros';
_fc_props.cloud_dvir__start_dvir = 'Paleisti DVIR';
_fc_props.cloud_dvir__dvir_history = 'DVIR istorija';
_fc_props.cloud_dvir__view_all = 'Peržiūrėti visus';
_fc_props.load_zone = 'Krovinio zona';
_fc_props.view_load_zones = 'Peržiūrėti apkrovos zonas';
_fc_props.edit_load_zone = 'Redaguoti apkrovos zoną';
_fc_props.create_a_load_zone = 'Sukurkite apkrovos zoną';
_fc_props.load_zone_panel = 'Apkrovos zonos skydas';
_fc_props.click_the_map_to_set_the_load_zone_center = 'Spustelėkite žemėlapį, kad nustatytumėte krovinio zonos centrą.';
_fc_props.cloud_dvir__mismatch_title_all_items_ok = 'Šios patikros metu nustatyti defektai, ir jūs nusprendėte, kad šią transporto priemonę saugu eksploatuoti. Prieš tęsdami, patvirtinkite.';
_fc_props.cloud_dvir__mismatch_title_needs_repair = 'Šios patikros metu defektų nenustatyta, ir jūs pasirinkote, kad ši transporto priemonė yra nesaugi eksploatuoti. Prieš tęsdami, patvirtinkite.';
_fc_props._90_days = '90 dienų';
_fc_props.cloud_dvir = 'Debesijos DVIR';
_fc_props.cloud_dvir_details = 'Debesijos DVIR pateikimai';
_fc_props.show_load_zones = 'rodyti apkrovos zonas';
_fc_props.hide_load_zones = 'slėpti krovinio zonas';
_fc_props.no = 'Ne';
_fc_props.cloud_dvir__reset = 'Atstatyti';
_fc_props.cloud_dvir__clear = 'Išvalyti';
_fc_props.mark_read = 'Markas Readas';
_fc_props.mark_unread = 'Pažymėti neskaitytą';
_fc_props.read = 'Skaityti';
_fc_props.unread = 'Neskaityta';
_fc_props.air_sensor_serial_number = 'Oro jutiklio serijos nr.';
_fc_props.air_sensor_mac_address = 'Oro jutiklio MAC adresas';
_fc_props.air_sensor_serial_number_invalid_format = 'Oro jutiklio serijos numeris netinkamu formatu: (raidinis ir skaitmeninis, ne ilgesnis kaip 32 simboliai su brūkšneliais)';
_fc_props.air_sensor_mac_address_invalid_format = 'Oro jutiklio MAC adresas nurodytas neteisingu šešioliktainiu formatu, kaip parodyta lauko vietos rezervavimo ženkle.';
_fc_props.air_sensor_license = 'Oro jutiklis';
_fc_props.adjust_route_point = 'Maršruto taško koregavimas';
_fc_props.route_point_panel = 'Maršruto taškų skydelis';
_fc_props.route_point = 'Maršruto punktas';
_fc_props.cloud_dvir__pre_trip = 'Prieš kelionę';
_fc_props.cloud_dvir__post_trip = 'Po kelionės';
_fc_props.cloud_dvir__other_insction_type = 'Kita';
_fc_props.cloud_dvir__dvir_completed = 'Užbaigta';
_fc_props.cloud_dvir__awaiting_mechanic = 'Laukiantis mechanikas';
_fc_props.cloud_dvir__awaiting_driver = 'Laukiama vairuotojo patvirtinimo';
_fc_props.unable_to_check_air_sensor_serial_number_please_contact_support_for_assistance = 'Nepavyko patikrinti oro jutiklio serijos numerio, kreipkitės į palaikymo tarnybą dėl papildomos pagalbos.';
_fc_props.this_air_sensor_serial_number_exists_please_use_another_serial_number = 'Šis oro jutiklio serijos numeris jau yra, naudokite kitą serijos numerį';
_fc_props.unable_to_check_air_sensor_mac_address_please_contact_support_for_assistance = 'Nepavyko patikrinti oro jutiklio MAC adreso, kreipkitės pagalbos į palaikymo tarnybą.';
_fc_props.cloud_dvir__error_submit_dvir_title = 'Pateikiant DVIR įvyko klaida';
_fc_props.cloud_dvir__error_submit_dvir_descr = 'Bandykite dar kartą';
_fc_props.ticket_integration_descr = 'Bilietų integravimas leidžia nustatyti bilietų integravimo nustatymus, taip pat pagrindinį ekraną / įkėlimo ekraną / standžiojo montavimo ekraną';
_fc_props.cloud_dvir__success_submit_dvir_title = 'DVIR sėkmingai pateiktas';
_fc_props.cloud_dvir__inspection_trip_type = 'Apžiūros kelionės tipas';
_fc_props.menu_dvir_title_mechanic = 'Mechanikas';
_fc_props.sidemenu_dvir = 'DVIR';
_fc_props.air_sensor_firmware = 'Oro jutiklio programinė įranga';
_fc_props.when_no_active_ticket = 'Kai nėra aktyvaus bilieto';
_fc_props.used_by = 'Naudotas iki';
_fc_props.fields = 'Laukai';
_fc_props.are_you_sure_you_want_to_delete_ticket_layout = 'Ar tikrai norite ištrinti bilieto maketą „{0}“?';
_fc_props.menu_settings_title_ticket_layout = 'Bilietų išdėstymas';
_fc_props.add_ticket_layout = 'Pridėti bilieto išdėstymą';
_fc_props.edit_ticket_layout = 'Redaguoti bilieto išdėstymą';
_fc_props.ticket_layout_edit_modal_name = 'Vardas';
_fc_props.ticket_layout_edit_modal_default = 'Numatytasis';
_fc_props.ticket_layout_edit_modal_error_message_name_empty = 'Klaida išsaugant bilieto maketą: turi būti užpildytas pavadinimo laukas.';
_fc_props.ticket_layout_edit_modal_error_message_name_invalid_format = 'Klaida išsaugant bilieto maketą: pavadinimo lauke gali būti tik raidės ir skaičiai';
_fc_props.ticket_layout_edit_modal_fields = 'Laukai';
_fc_props.ticket_layout_edit_modal_usage = 'Naudojimas';
_fc_props.ticket_layout_has_been_removed_please_refresh_page = 'Bilietų išdėstymas pašalintas. Atnaujinkite puslapį.';
_fc_props.more_lower_case = 'daugiau';
_fc_props.ticket_layout_edit_modal_error_selected_fields_are_empty = 'Klaida išsaugant bilieto maketą: reikia pasirinkti vieną ar daugiau laukų.';
_fc_props.ticket_layout_edit_modal_error_selected_statuses_are_empty = 'Klaida išsaugant bilieto maketą: reikia pasirinkti vieną ar daugiau būsenų.';
_fc_props.cloud_dvir__ad_hoc = 'Ad hoc';
_fc_props.radius_multiplier_should_be = 'Spindulio daugiklis turėtų būti slankiojantis skaičius';
_fc_props.ticket_max_activate_age_err = 'Bilietų maksimalaus aktyvavimo amžiaus minutės turi būti sveikasis skaičius.';
_fc_props.max_hotspot_unused_days_errs = 'Maksimalus nenaudojamų viešosios prieigos taškų skaičius (Daugiausia dienų) turėtų būti sveikasis skaičius.';
_fc_props.begin_pour_air_content = 'Pradėkite pilti oro kiekį';
_fc_props.arrival_air_content = 'Atvykimo oro turinys';
_fc_props.fully_mixed_air_content = 'Visiškai sumaišytas oro kiekis';
_fc_props.departure_air_content = 'Išvykimo oro turinys';
_fc_props.popup_enabled = 'Iššokantys langai įjungti';
_fc_props.popup_disabled = 'Iššokantys langai išjungti';
_fc_props.cloud_dvir__leave_confirmation_title = 'Įspėjimas';
_fc_props.cloud_dvir__leave_confirmation_description = 'Išėjus iš puslapio dabar, visi pakeitimai bus prarasti.';
_fc_props.cloud_dvir__leave_confirmation_approve = 'Patvirtinti';
_fc_props.cloud_dvir__leave_confirmation_abort = 'Atšaukti';
_fc_props.air_bt_ratio = 'Oro jutiklio matavimas';
_fc_props.cloud_dvir__view_photos_notes = 'Peržiūrėti nuotraukas / užrašus';
_fc_props.error_adding_the_status_it_will_create_a_blank_usage_in_another_ticket_layout = 'Pridėjus būseną, kitame bilietų makete bus sukurtas tuščias panaudojimas. Ar norite tęsti pridėjimą?';
_fc_props.vehicle_does_not_have_air_sensor_license = 'Transporto priemonė neturi oro jutiklio licencijos.';
_fc_props.air_sensor_installed = 'Įrengtas oro jutiklis';
_fc_props.load_card = 'Įkelti kortelę';
_fc_props.cloud_dvir__inspection_profile = 'Apžiūros profilis';
_fc_props.cloud_dvir__view_details = 'Peržiūrėti išsamią informaciją';
_fc_props.cloud_dvir__certify_repairs = 'Sertifikuoti remontą';
_fc_props.cloud_dvir__repairs_made = 'Atlikti remontai';
_fc_props.cloud_dvir__repairs_not_necessary = 'Remontas nereikalingas';
_fc_props.cloud_dvir__mechanic_note_from = 'Mechaniko pastaba iš';
_fc_props.cloud_dvir__mechanic_assignment = 'Mechaniko užduotis';
_fc_props.cloud_dvir__mechanic_signature_description = 'Pažymėkite visus taikomus punktus žemiau ir pasirašykite, nurodydami, kad transporto priemonė buvo tinkamai patikrinta.';
_fc_props.cloud_dvir__condition_satisfactory_label = 'Šios transporto priemonės būklė patenkinama';
_fc_props.cloud_dvir__defects_corrected_label = 'Defektai buvo ištaisyti';
_fc_props.cloud_dvir__repair_not_required_label = 'Remontas nereikalingas saugiam transporto priemonės eksploatavimui';
_fc_props.safety = 'Saugumas';
_fc_props.cloud_dvir__awaiting_sign = 'Laukimo ženklas';
_fc_props.cloud_dvir__dvir_review = 'DVIR apžvalga';
_fc_props.settings.mobile_auto_start_navigation = 'Automatinis navigacijos paleidimas mobiliajame įrenginyje';
_fc_props.cloud_dvir__edit = 'Redaguoti';
_fc_props.delete_custom_label = 'Ištrinti pasirinktinę etiketę';
_fc_props.cloud_dvir__error_incompatible_aux_version = 'Jūsų „TrackIt“ versija pasenusi ir kai kurios DVIR funkcijos gali neveikti tinkamai. Prieš tęsdami, atnaujinkite „TrackIt“.';
_fc_props.cloud_dvir__error_submit_dvir_signature = 'Įkeliant parašą įvyko klaida. Bandykite dar kartą.';
_fc_props.max_hotspot_unused_days_error = 'Maksimalus nenaudojamų karštųjų taškų skaičius gali būti 1000 dienų.';
_fc_props.menu_dvir_title_admin_templates = 'Šablonai';
_fc_props.menu.dvir = {};
_fc_props.menu.dvir.admin = {};
_fc_props.menu.dvir.admin.title = 'Administratorius';
_fc_props.cloud_dvir__admin_templates = 'Šablonai';
_fc_props.form_name = 'Formos pavadinimas';
_fc_props.form_status = 'Formos būsena';
_fc_props.menu.dvir.title = 'DVIR';
_fc_props.cloud_dvir__option_download = 'Atsisiųsti';
_fc_props.cloud_dvir__option_view = 'Peržiūrėti';
_fc_props.cloud_dvir__inspectortype_driver = 'Vairuotojas';
_fc_props.menu.dvir.description = {};
_fc_props.menu.dvir.description.admin = 'Peržiūrėti / redaguoti / kurti pasirinktines DVIR formas ir pateikimus';
_fc_props.menu.dvir.description.mechanic = 'Peržiūrėti / redaguoti veiksmingą DVIR pateiktį';
_fc_props.not_in_use = 'Nenaudojamas';
_fc_props.logged_in = 'prisijungęs';
_fc_props.reviewing_driver = 'Apžvalginis vairuotojas';
_fc_props.cloud_dvir__report_title = 'Vairuotojo transporto priemonės apžiūros ataskaita';
_fc_props.cloud_dvir__report_signed = 'pasirašytas';
_fc_props.cloud_dvir__report_page_counter = '{0} puslapis iš {1}';
_fc_props.cloud_dvir__report_defects = 'Defektai';
_fc_props.cloud_dvir__report_comments = 'Komentarai';
_fc_props.cloud_dvir__report_inspection_table_title = 'Transporto priemonės apžiūra';
_fc_props.cloud_dvir__report_driver_table_title = 'Vairuotojo informacija';
_fc_props.cloud_dvir__report_carrier = 'Vežėjas';
_fc_props.cloud_dvir__report_truck = 'Sunkvežimis';
_fc_props.cloud_dvir__report_location = 'Vieta';
_fc_props.cloud_dvir__report_odometer = 'Odometras';
_fc_props.cloud_dvir__report_hours = 'Darbo valandos';
_fc_props.cloud_dvir__report_no_comments = 'Nėra komentarų';
_fc_props.include_unlicensed_vehicles = 'Įtraukti nelicencijuotas transporto priemones';
_fc_props.cloud_dvir__search_by_form_name = 'Ieškoti pagal formos pavadinimą';
_fc_props.cloud_dvir__create_dvir = 'Sukurkite DVIR';
_fc_props.cloud_dvir__update_dvir = 'Atnaujinti DVIR';
_fc_props.cloud_dvir__form_name = 'Formos pavadinimas';
_fc_props.cloud_dvir__form_description = 'Formos aprašymas';
_fc_props.cloud_dvir__form_status = 'Formos būsena';
_fc_props.information = 'Informacija';
_fc_props.cloud_dvir__search_categories = 'Paieškos kategorijos';
_fc_props.cloud_dvir__create_new_category = 'Sukurti naują kategoriją';
_fc_props.category_name = 'Kategorijos pavadinimas';
_fc_props.sub_category = 'Subkategorija';
_fc_props.sub_category_name = 'Subkategorijos pavadinimas';
_fc_props.delete_category = 'Ištrinti kategoriją';
_fc_props.cloud_dvir__dvir_information = 'DVIR informacija';
_fc_props.cloud_dvir__dvir_choose_categories = 'Pasirinkite kategorijas';
_fc_props.cloud_dvir__create_category = 'Sukurti kategoriją';
_fc_props.cloud_dvir__update_category = 'Atnaujinti kategoriją';
_fc_props.delete_route_point = 'Ištrinti maršruto tašką';
_fc_props.view_route_points = 'Peržiūrėti maršruto taškus';
_fc_props.ignore_cancel_preload = 'Nepaisykite atšaukimo, jūsų duomenys iš anksto įkelti. Jūsų muštas homerunas bus parodytas netrukus.';
_fc_props.cloud_dvir__assigned_mechanic = 'Paskirtas mechanikas';
_fc_props.cloud_dvir__add_mechanic = 'Pridėti mechaniką';
_fc_props.contact_type = 'Kontakto tipas';
_fc_props.cloud_dvir__send_email_notifications = 'Siųsti el. pašto pranešimus';
_fc_props.menu_dvir_title_admin_dvir = 'DVIR';
_fc_props.cloud_dvir__error_retrieving_dvir_history = 'Klaida gaunant DVIR istorijos įrašus.';
_fc_props.cloud_dvir__error_processing_dvir_record = 'Klaida gaunant DVIR įrašą.';
_fc_props.cloud_dvir__error_saving_submission = 'Išsaugojant pateiktą informaciją įvyko klaida. Bandykite dar kartą.';
_fc_props.cloud_dvir__error_retrieving_mechanics = 'Klaida gaunant mechanikų sąrašą.';
_fc_props.cloud_dvir__template_saved = 'Šablonas išsaugotas';
_fc_props.cloud_dvir__error_retrieving_dvir_templates = 'Klaida gaunant šablonų sąrašą.';
_fc_props.cloud_dvir__error_saving_dvir_template = 'Klaida išsaugant šabloną. Bandykite dar kartą.';
_fc_props.dispatch_group = 'Dispečerinė grupė';
_fc_props.save_adjust = 'Maršruto taško išsaugojimas ir koregavimas';
_fc_props.reset_route_point = 'Maršruto taško atstatymas';
_fc_props.no_records_stub_adjust_filters = 'Pabandykite pakoreguoti paieškos arba filtro nustatymus, kad padidintumėte rezultatų skaičių.';
_fc_props.no_dvir_records = 'Visi susitvarkė su DVIR!';
_fc_props.no_dvir_records_sub_title = 'Jūs daug pasiekėte';
_fc_props.settings.master_data_connex_x_api_key = 'Pagrindinių duomenų „Connex“ x-API raktas';
_fc_props.slump_not_obtained_for_x = 'Nuosmukio rodmenys negauti: {0}';
_fc_props.please_select_a_sensor_status_type = 'Pasirinkite jutiklio būsenos tipus, kad suaktyvintumėte šį įspėjimą';
_fc_props.settings.master_data_connex_token = 'Pagrindinių duomenų „Connex“ prieigos raktas';
_fc_props.error_validating_master_data_connex_credentials = 'Klaida patvirtinant „Master Data Connex“ kredencialus';
_fc_props.settings.master_data_connex_base_url = 'Pagrindinių duomenų „Connex“ bazinis URL';
_fc_props.settings.master_data_connex_exp_time = 'Pagrindinių duomenų „Connex“ galiojimo laikas';
_fc_props.download_template = 'Atsisiųsti šabloną';
_fc_props.menu_settings_title_dispatch_group = 'Dispečerinės grupės';
_fc_props.settings.dispatch_groups = 'Dispečerinės grupės';
_fc_props.dispatch_group_name = 'Dispečerinės grupės pavadinimas';
_fc_props.dispatch_group_plants = 'Dispečerinės grupės gamyklos';
_fc_props.dispatch_group_plants_mapping_message = 'Nurodykite, kurie augalai bus šios dispečerinės grupės dalis.';
_fc_props.dispatch_group_users_mapping_message = 'Nurodykite, kurie vartotojai bus šios dispečerinės grupės dalis.';
_fc_props.dispatch_group_plant_disassociation_message = 'Augalas vienu metu turėtų būti pavaldus vienai dispečerinei grupei.';
_fc_props.dispatch_group_search_by_plant = 'Ieškoti pagal augalo pavadinimą';
_fc_props.dispatch_group_search_by_username = 'Ieškoti pagal vartotojo vardą';
_fc_props.search_by_dispatch_group_name = 'Ieškoti pagal dispečerinės grupės pavadinimą';
_fc_props.create_dispatch_group = 'Sukurkite dispečerinę grupę';
_fc_props.update_dispatch_group = 'Atnaujinti dispečerinę grupę';
_fc_props.dispatch_group_saved = 'Dispečerinė grupė išsaugota';
_fc_props.warning_deleting_dispatch_group_unassociate_plants = 'Ištrynus šią dispečerinę grupę, bus sukurtos numatytosios dispečerinės grupės susijusiems augalams.';
_fc_props.error_saving_dispatch_group = 'Klaida išsaugant siuntimo grupę. Bandykite dar kartą.';
_fc_props.please_enter_a_valid_plant_num = 'Įveskite galiojantį gamyklos numerį.';
_fc_props.cloud_dvir__report_no_defects = 'Be defektų';
_fc_props.shoud_select_dispatch_group = 'Turite pasirinkti bent vieną siuntimo grupę';
_fc_props.one_or_more_users_are_associated_with_this_dispatch_group_only = 'Nepavyko ištrinti, nes šioje dispečerinėje grupėje yra naudotojų, kurie susieti tik su šia dispečerine grupe.';
_fc_props.cloud_dvir__username = 'Vartotojo vardas';
_fc_props.cloud_dvir__password = 'Slaptažodis';
_fc_props.cloud_dvir__login = 'Prisijungti';
_fc_props.cloud_dvir__mechanic_sign_in = 'Mechaniko prisijungimas';
_fc_props.delete_dispatch_group = 'Ištrinti siuntimo grupę';
_fc_props.cloud_dvir__driver = 'Vairuotojas';
_fc_props.cloud_dvir__equipment_pound = 'Įrangos numeris';
_fc_props.cloud_dvir__mechanic = 'Mechanikas';
_fc_props.dispatch_group_user_only_unassociate_message = 'Nepavyko ištrinti vartotojo, nes vartotojai turi būti susieti su bent viena dispečerinių grupių.';
_fc_props.cloud_dvir__time_period_filter_today = 'Šiandien';
_fc_props.cloud_dvir__time_period_filter_yesterday = 'Vakar';
_fc_props.cloud_dvir__time_period_filter_last_7_days = 'Paskutinės 7 dienos';
_fc_props.cloud_dvir__time_period_filter_last_30_days = 'Paskutinės 30 dienų';
_fc_props.cloud_dvir__date_range_filter = 'Filtruoti pagal datą';
_fc_props.cloud_dvir__download = 'Atsisiųsti';
_fc_props.dispatch_group_is_empty = 'Siuntimo grupės laukas negali būti tuščias.';
_fc_props.dispatch_group_with_empty_plants = 'Su dispečerinių grupe turi būti susieta bent viena gamykla.';
_fc_props.dispatch_group_with_empty_users = 'Bent vienas vartotojas turi būti susietas su dispečerinių grupe.';
_fc_props.not_delete_one_or_more_users_are_associated_with_this_dispatch_group_only = 'Nepavyko ištrinti dispečerinės grupės, nes joje yra naudotojų, kurie susieti tik su šia dispečerine grupe.';
_fc_props.dispatch_group_not_exists = 'Dispečerinė grupė neegzistuoja.';
_fc_props.dispatch_group_contains_one_plant = 'Nepavyko ištrinti, nes šioje dispečerinėje grupėje yra tik vienas augalas.';
_fc_props.dispatch_group_users = 'Dispečerinės grupės naudotojai';
_fc_props.cloud_dvir__error_retrieving_dvir = 'Klaida gaunant DVIR įrašą';
_fc_props.cloud_dvir__assign_mechanic = 'Priskirti mechaniką';
_fc_props.cloud_dvir__submit_review = 'Pateikti atsiliepimą';
_fc_props.error_deleting_dispatch_group = 'Ištrinant siuntimo grupę įvyko klaida.';
_fc_props.error_retrieving_dispatch_groups = 'Klaida gaunant siuntimo grupių sąrašą.';
_fc_props.cloud_dvir__undo_selection = 'Atšaukti pasirinkimą';
_fc_props.enable_master_data = 'Įjungti pagrindinius duomenis';
_fc_props.manually_sync = 'Rankinis sinchronizavimas';
_fc_props.master_data_connex_token_expiration = 'Pagrindinių duomenų „Connex“ žetono galiojimo pabaiga';
_fc_props.cloud_dvir__time_period_filter_custom = 'Pasirinktinis';
_fc_props.settings.zello_session_timeout_minutes = '„Zello“ seanso skirtasis laikas (minutėmis)';
_fc_props.menu_settings_title_master_data = 'Pagrindiniai duomenys';
_fc_props.settings.master_data = 'Pagrindiniai duomenys';
_fc_props.error_retrieving_master_data = 'Klaida gaunant pagrindinius duomenis';
_fc_props.master_data_sync_completed = 'Pagrindinių duomenų sinchronizavimas baigtas';
_fc_props.master_data_successfully_updated = 'Duomenys sėkmingai atnaujinti';
_fc_props.master_data_failed_to_update = 'Nepavyko išsaugoti.';
_fc_props.master_data_sync_initiated = 'Praduotas pagrindinių duomenų sinchronizavimas';
_fc_props.master_data_sync_failed = 'Pagrindinių duomenų sinchronizavimas nepavyko';
_fc_props.enabled_excluding_origin_on_deliveries = 'Tiesa (išskyrus kilmės nurodymą pristatymo kvituose)';
_fc_props.enabled_including_origin_on_deliveries = 'Tiesa (įskaitant kilmės šalį pristatymo kvituose)';
_fc_props.cloud_dvir__i_will_decide_later = 'nuspręsiu vėliau';
_fc_props.returning = 'Grįžimas';
_fc_props.leftover_concrete = 'Likęs betonas';
_fc_props.leftover_concrete_on_vehicle_x = 'Ant transporto priemonės likęs betonas {0}';
_fc_props.leftover_concrete_alert = 'Įspėjimas apie likusius betono likučius';
_fc_props.wc_ratio_exceeded = 'Viršytas vandens ir vandens santykis';
_fc_props.search_by_site_name = 'Ieškoti pagal svetainės pavadinimą';
_fc_props.sites = 'Svetainės';
_fc_props.token_expiration = 'Žetono galiojimo laikas';
_fc_props.menu_settings_title_connex_api_key_management = '„Connex“ API raktų valdymas';
_fc_props.settings.connex_api_key_management = '„Connex“ API raktų valdymas';
_fc_props.error_retrieving_connex_api_key_data = 'Klaida gaunant „Connex API“ rakto duomenis';
_fc_props.qr_code = 'QR kodas';
_fc_props.informing_driver_and_interface_when_entering_wrong_plant = 'Vairuotojo ir sąsajos informavimas apie įvažiavimą į neteisingą gamyklą';
_fc_props.enable_driver_message = 'Įjungti vairuotojo pranešimą';
_fc_props.enable_dispatch_message = 'Įgalinti išsiuntimo pranešimą';
_fc_props.enable_sending_message_to_interface = 'Įgalinti pranešimų siuntimą į sąsają';
_fc_props.ticket_qr_code = 'QR kodas';
_fc_props.leftover_concrete_alert_description = 'Įspėti, kai po betono liejimo randama betono likučių.';
_fc_props.minimum_leftover_concrete_amount = 'Minimalus likęs betono kiekis';
_fc_props.error_validating_master_data_connex_credentials_unauthorized = 'Klaida patvirtinant „Master Data Connex“ kredencialus. Neautorizuota.';
_fc_props.error_validating_master_data_connex_credentials_permissions = 'Klaida patvirtinant „Master Data Connex“ kredencialų teises';
_fc_props.error_validating_master_data_connex_url_not_found = 'Klaida tikrinant pagrindinių duomenų jungties URL nerastas';
_fc_props.error_validating_master_data_connex_unknown_error = 'Klaida patvirtinant pagrindinius duomenis „Connex“ sistemoje. Nežinoma klaida.';
_fc_props.master_data_sync_failed_sync_up_vehicle_type = 'Pagrindinių duomenų sinchronizavimas nepavyko. Sinchronizuokite transporto priemonės tipą.';
_fc_props.master_data_sync_failed_sync_up_vehicle = 'Pagrindinių duomenų sinchronizavimas nepavyko. Sinchronizuokite transporto priemonę.';
_fc_props.master_data_sync_failed_sync_up_plant = 'Pagrindinių duomenų sinchronizavimas nepavyko. Sinchronizuokite gamyklą.';
_fc_props.master_data_sync_failed_data_base_connection = 'Pagrindinių duomenų sinchronizavimas nepavyko prisijungti prie duomenų bazės.';
_fc_props.error_validating_master_data_connex_permission_is_insufficient = 'Klaida patvirtinant „Master Data Connex“ kredencialus. Nepakanka turėtojo prieigos rakto leidimo.';
_fc_props.settings.back_date_arrive_job = 'Atgalinė atvykimo data į darbą';
_fc_props.device_notifications = 'Pranešimai';
_fc_props.loading_number = 'Pakrovimo numeris';
_fc_props.leftover_concrete_volume_temp_age = 'Likęs tūris={0}, Laikinas={1}, Amžius={2}';
_fc_props.total_ordered = 'Bendras užsakytas kiekis';
_fc_props.total_ticketed = 'Pristatytas Užsakytas';
_fc_props.load_number = 'Krovinio numeris';
_fc_props.min_leftover_concrete_must_be_filled_in_and_gt_x = 'Minimalus betono likutis turi būti užpildytas ir didesnis nei {0}';
_fc_props.error_validating_master_data_connex_credentials_are_the_same = 'Klaida tikrinant pagrindinius duomenis. Prisijungimo duomenys negali būti tokie patys.';
_fc_props.use_aws_for_talk = 'Naudokite AWS pokalbiams';
_fc_props.air_readings_not_supported = 'Oro rodmenys nepalaikomi';
_fc_props.air_not_supported = 'Oras nepalaikomas';
_fc_props.mix_not_supported = 'Mišinys nepalaikomas';
_fc_props.air_default_and_none_not_supported = 'Negalima vienu metu pasirinkti numatytosios ir nepalaikomos!';
_fc_props.notifications_enabled = 'Pranešimai įjungti';
_fc_props.prevent_status_change = 'Užkirsti kelią būsenos pakeitimui';
_fc_props.message_to_interface = 'Pranešimas sąsajai';
_fc_props.prevent_wrong_plant = 'Užkirsti kelią netinkamam augalui';
_fc_props.previous_tickets = 'Ankstesni bilietai';
_fc_props.audit_ticket_number = 'Bilieto numeris';
_fc_props.audit_date_created = 'Sukūrimo data';
_fc_props.audit_vehicle_number = 'Transporto priemonės numeris';
_fc_props.cloud_dvir__table_ok = 'Saugu naudoti';
_fc_props.cloud_dvir__table_needs_repair = 'Nesaugu eksploatuoti';
_fc_props.missing_air_calibration = 'Nėra oro kalibravimo duomenų';
_fc_props.reported_defects = 'Pranešti defektai';
_fc_props.address_latitude = 'Adreso platuma';
_fc_props.address_longitude = 'Adreso ilguma';
_fc_props.routing_latitude = 'Maršruto platuma';
_fc_props.routing_longitude = 'Maršruto ilguma';
_fc_props.category_name_must_be_unique = 'Kategorijos pavadinimas turi būti unikalus';
_fc_props.subcategory_name_must_be_unique = 'Subkategorijos pavadinimas turi būti unikalus';
_fc_props.menu_settings_tracking_device = 'Sekimo įrenginys';
_fc_props.menu_settings_title_tracking_device = 'Sekimo įrenginys';
_fc_props.menu_settings_title_personal_device_registration = 'Asmeninio įrenginio registracija';
_fc_props.registration_code = 'Registracijos kodas';
_fc_props.creation_date = 'Sukūrimas';
_fc_props.expiration_date = 'Galiojimo laikas';
_fc_props.trackitadmin_personal_device_registration = 'Asmeninio įrenginio registracija';
_fc_props.create_registration_code = 'Pridėti registracijos kodą';
_fc_props.remove_registration_code = 'Pašalinti registracijos kodą';
_fc_props.add_a_registration_code = 'Pridėti registracijos kodą';
_fc_props.select_number_of_registration_codes_to_generate = 'Pasirinkite norimų sugeneruoti registracijos kodų skaičių.';
_fc_props.registration_code_count = 'Registracijos kodų skaičius';
_fc_props.are_you_sure_you_want_to_delete_this_reg_code = 'Ar tikrai norite ištrinti pasirinktą registruotą kodą?';
_fc_props.are_you_sure_you_want_to_delete_selected_reg_codes = 'Ar tikrai norite ištrinti pasirinktus registruotus kodus?';
_fc_props.add_personal_device = 'Pridėti asmeninį įrenginį';
_fc_props.menu_settings_title_personal_device = 'Asmeninis įrenginys';
_fc_props.cloud_dvir__approval_critical_alert = 'Transporto priemonė turi kritinį defektą. Negalima pažymėti kaip saugios eksploatuoti.';
_fc_props.export_registration_codes = 'Eksporto registracijos kodai';
_fc_props.download_format = 'Atsisiuntimo formatas';
_fc_props.specify_download_format_x = 'Nurodykite atsisiuntimo formatą, kad eksportuotumėte {0} registracijos kodus';
_fc_props.personal_device_download = 'Atsisiųsti';
_fc_props.add_personal_device_input_message = 'Žemiau įveskite asmeninio įrenginio ID. Galiojimo laikas bus automatiškai pritaikytas išsaugojus';
_fc_props.error_creating_personal_device = 'Kuriant asmeninį įrenginį įvyko klaida';
_fc_props.device_already_exists = 'Asmeninis įrenginys jau yra';
_fc_props.export = 'Eksportuoti';
_fc_props.error_can_not_change_connex_eid = 'Negalima pakeisti „Connex eid“, nes jis šiuo metu naudojamas pagrindiniams duomenims.';
_fc_props.remove_personal_device = 'Pašalinti asmeninį įrenginį';
_fc_props.are_you_sure_you_want_to_delete_this_personal_device = 'Ar tikrai norite ištrinti pasirinktą asmeninį įrenginį?';
_fc_props.are_you_sure_you_want_to_delete_selected_personal_devices = 'Ar tikrai norite ištrinti pasirinktus asmeninius įrenginius?';
_fc_props.error_deleting_personal_device = 'Klaida ištrinant asmeninį įrenginį';
_fc_props.customerid = 'Kliento ID';
_fc_props.customername = 'Kliento vardas';
_fc_props.ordernumber = 'Užsakymo numeris';
_fc_props.orderdescription = 'Užsakymo aprašymas';
_fc_props.locationid = 'Vietovės ID';
_fc_props.locationdescription = 'Vietos aprašymas';
_fc_props.productid = 'Produkto ID';
_fc_props.productdescription = 'Produkto aprašymas';
_fc_props.vehicleid = 'Transporto priemonės ID';
_fc_props.vehicledescription = 'Transporto priemonės aprašymas';
_fc_props.ticketnumber = 'Bilieto Nr.';
_fc_props.ticketdate = 'Bilieto data / laikas';
_fc_props.drivername = 'Vairuotojo vardas';
_fc_props.arriveregion = 'Atvykimo regionas (LAIKAS)';
_fc_props.leaveregion = 'Išvykimo regionas (TIME)';
_fc_props.regionduration = 'Regiono trukmė';
_fc_props.menu_reports_title_prevailing_wage = 'Vyraujantis darbo užmokestis';
_fc_props.slump_calibration_x_not_found_for_y = 'Nuosmukio kalibravimas „{0}“ nerastas pagal bilietą {1}';
_fc_props.slump_calibration_not_found = 'Nuosmukio kalibravimas nerastas';
_fc_props.slump_calibration_not_found_description = 'Įspėjimas, kai nerandamas nuosmukio kalibravimas';
_fc_props.error_getting_personal_device_list = 'Klaida gaunant asmeninių įrenginių sąrašą';
_fc_props.batch_summary_date_range_note = '*PASTABA: Jei netaikomi filtrai, ši ataskaita pateikiama tik pagal 3 dienas. Filtruojant pagal įrangą (daugiausia 10), gamyklą (daugiausia 1), produktą (daugiausia 1) arba darbą (daugiausia 1), datų diapazonas gali siekti 31 dieną.';
_fc_props.select_registration_code_expiration_time_days = 'Pasirinkite dienų skaičių iki registracijos kodų galiojimo pabaigos ir spustelėkite „Išsaugoti“.';
_fc_props.add_personal_device_expiration = 'Galiojimo laikas (dienomis)';
_fc_props.cloud_dvir__vehicle_no = 'Transporto priemonės Nr.';
_fc_props.cloud_dvir__trailer_no = 'Priekabos Nr.';
_fc_props.cloud_dvir__vehicle = 'Transporto priemonė';
_fc_props.cloud_dvir__trailer = 'Priekaba';
_fc_props.cloud_dvir__truck_number_label = 'Sunkvežimio numeris';
_fc_props.cloud_dvir__trailer_number = 'Priekabos numeris';
_fc_props.cloud_dvir__has_trailer = 'Nevažiuojant su priekaba';
_fc_props.cloud_dvir__trailer_input_field_prompt = 'Įveskite savo priekabos numerį čia';
_fc_props.work_order = 'Darbo užsakymas';
_fc_props.unable_to_determine_slump = 'Nepavyko nustatyti nuosmukio';
_fc_props.cloud_dvir__determine_the_overall_condition_of_the_trailer = 'Nustatykite bendrą priekabos būklę';
_fc_props.defaultTrailer = 'Numatytasis anonsas';
_fc_props.trailer_type_column_billable = 'Apmokestinama';
_fc_props.trailer_type_column_notes = 'Pastabos';
_fc_props.trailer_type_column_date = 'Data';
_fc_props.trailer_type_column_order = 'Užsakymas';
_fc_props.trailer_type_column_ticket = 'Bilietas';
_fc_props.trailer_type_column_project = 'Projektas';
_fc_props.trailer_type_column_customer = 'Klientas';
_fc_props.trailer_type_column_location = 'Vieta';
_fc_props.trailer_type_column_vehicle_type = 'Transporto priemonės tipas';
_fc_props.trailer_type_column_product = 'Produktas';
_fc_props.trailer_type_action_rebill = 'Pakartotinis sąskaitų faktūrų išrašymas';
_fc_props.master_data_sync_failed_no_default_vehicle_type_has_been_set = 'Pagrindinių duomenų sinchronizavimas nepavyko, nenustatytas numatytasis įrangos tipas';
_fc_props.trailer_type = 'Priekabos tipas';
_fc_props.trailer_type_is_required = 'Būtina nurodyti priekabos tipą';
_fc_props.trailer_number_already_exists = 'Priekabos numeris jau yra';
_fc_props.plate_number_already_exists = 'Valstybinis numeris jau yra';
_fc_props.trailer_vin_already_exists = 'Anonso Vin jau yra';
_fc_props.trailer_does_not_exist = 'Anonso nėra';
_fc_props.trailer_number_is_required = 'Būtina nurodyti priekabos numerį';
_fc_props.plate_number_is_required = 'Būtina nurodyti valstybinį numerį';
_fc_props.plate_number = 'Valstybinis numeris';
_fc_props.menu_settings_title_trailer = 'Priekaba';
_fc_props.add_trailer = 'Pridėti anonsą';
_fc_props.edit_trailer = 'Redaguoti anonsą';
_fc_props.menu_settings_title_equipment = 'Įranga';
_fc_props.settings_ignore_new_tickets_from_command_cloud_older_than_specified_minutes = 'Ignoruoti naujus „Command Cloud“ bilietus, senesnius nei X minučių';
_fc_props.settings_ignore_new_tickets_from_command_cloud_older_than_specified_minutes_title = 'Ignoruoti naujus bilietus iš „Command Cloud“, kurių išsiuntimo data ir laikas yra senesni nei X minučių (numatytoji reikšmė yra tuščia ir išjungta)';
_fc_props.edit_load_card = 'Redaguoti įkėlimo kortelę';
_fc_props.default_layout = 'Numatytasis išdėstymas';
_fc_props.load_card_empty_fields = 'Klaida išsaugant įkėlimo kortelę: reikia pasirinkti vieną ar daugiau laukų.';
_fc_props.trailers = 'Priekabos';
_fc_props.error_failed_to_save_data = 'Klaida: Nepavyko išsaugoti duomenų';
_fc_props.slump_increased_plasticizer_added_question = 'Kiek plastifikatoriaus buvo pridėta?';
_fc_props.add_trailer_type = 'Pridėti priekabos tipą';
_fc_props.menu_settings_title_trailer_type = 'Priekabos tipas';
_fc_props.edit_trailer_type = 'Redaguoti anonso tipą';
_fc_props.single_use_codes = 'Vienkartinio naudojimo kodai';
_fc_props.multiple_use_codes = 'Daugkartinio naudojimo kodai';
_fc_props.trailer_type_description_is_required = 'Priekabos tipo aprašymas būtinas';
_fc_props.trailer_saved = 'Anonsas išsaugotas';
_fc_props.cloud_dvir__trailer_only_dvir = 'Tik anonsas DVIR';
_fc_props.choose_file = 'Pasirinkite failą';
_fc_props.no_file_chosen = 'Nepasirinktas failas';
_fc_props.please_choose_file = 'Pasirinkite failą';
_fc_props.no_filters = 'Nepasirinkta jokių filtrų';
_fc_props.remaining_defects = 'Likę defektai';
_fc_props.load_more = 'Įkelti daugiau';
_fc_props.pagination_label = '{0}–{1} iš {2}';
_fc_props.extend = 'Išplėsti';
_fc_props.cloud_dvir__notes_or_photo_required = 'Reikalingi arba užrašai, arba nuotrauka.';
_fc_props.no_default_plant_specified_failed_to_save = 'Nenurodytas numatytasis augalas.';
_fc_props.no_default_employee_type_specified_failed_to_save = 'Nenurodytas numatytasis darbuotojo tipas.';
_fc_props.personal_device_registration_code_saved = 'Asmeninis įrenginio registracijos kodas išsaugotas';
_fc_props.error_saving_personal_device_registration_code = 'Klaida išsaugant asmeninio įrenginio registracijos kodą. Bandykite dar kartą.';
_fc_props.settings.master_data_sub_title = 'Pagrindinių duomenų integracijos tarp „TrackIt“ ir „Connex“ nustatymas';
_fc_props.connex_authentication = '{0} Autentifikavimas';
_fc_props.select_company = 'Pasirinkite įmonę';
_fc_props.requirements = 'Reikalavimai';
_fc_props.default_plant_type = 'Numatytasis augalas';
_fc_props.default_employee_type = 'Numatytasis darbuotojo tipas';
_fc_props.default_equipment_type = 'Numatytasis įrangos tipas';
_fc_props.support_alphanumeric_trucks = 'Palaikykite raidinius ir skaitmeninius sunkvežimius';
_fc_props.no_default_equipment_type_specified_failed_to_save = 'Nenurodytas numatytasis įrangos tipas.';
_fc_props.air_pau_battery_low_message = 'Oro PAU akumuliatoriaus išsikrovimo įspėjimas';
_fc_props.air_pau_battery_low = 'Oro PAU baterija išsikrovė';
_fc_props.alert_when_air_pau_battery_low = 'Įspėjimas, kai „Air PAU“ akumuliatoriaus įkrova maža';
_fc_props.air_pau_battery_low_alert = 'Įspėjimas apie išsikrovusį oro akumuliatorių';
_fc_props.sensor_unable_to_determine_slump = 'Jutiklis negali nustatyti nuosmukio';
_fc_props.menu_settings_title_export = 'Eksportuoti';
_fc_props.compare_company = 'Palyginkite su kita įmone';
_fc_props.site_settings = 'Svetainės nustatymai';
_fc_props.permission_type = 'Leidimo tipas';
_fc_props.ticket_integration = 'Bilietų integracija';
_fc_props.select_one_or_more_settings = 'Pasirinkite vieną ar daugiau nustatymų';
_fc_props.export_tooltip = 'Ši parinktis galima tik tuo atveju, jei priklausote daugiau nei vienai įmonei.';
_fc_props.select_company_error = 'Pasirinkite įmonę';
_fc_props.audible = 'Garsinis';
_fc_props.deleted_master_data_successfully = 'Pagrindiniai duomenys sėkmingai ištrinti';
_fc_props.cloud_dvir__units_miles_abbr = 'MI';
_fc_props.cloud_dvir__units_kilometers_abbr = 'KM';
_fc_props.create_hauler_order = 'Sukurti vežėjo užsakymą';
_fc_props.send_gps = 'Siųsti GPS';
_fc_props.cloud_dvir__search_results = 'Paieškos rezultatai';
_fc_props.cloud_dvir__advanced_filter = 'Išplėstinis filtras';
_fc_props.preload = 'Išankstinis įkrovimas';
_fc_props.job_name = 'Pareigybės pavadinimas';
_fc_props.delivery_address = 'Pristatymo adresas';
_fc_props.total_water_added = 'Iš viso pridėto vandens';
_fc_props.total_customer_water_added = 'Bendras klientų pridėto vandens kiekis';
_fc_props.concrete_volume = 'Betono tūris';
_fc_props.water_events_and_volume = 'Vandens įvykiai ir tūris';
_fc_props.menu.reports.title.water_events_and_volume = 'Vandens įvykiai ir tūris';
_fc_props.menu.reports.description = {};
_fc_props.menu.reports.description.water_events_and_volume = 'Peržiūrėkite vandens kiekį, pridėtą prie įvairių būsenų ir grupių bilietų';
_fc_props.returned_concrete_volume = 'Grąžinto betono tūris';
_fc_props.customer_water_added = 'Kliento pridėtas vanduo';
_fc_props.averages_and_totals = 'Vidurkiai ir sumos';
_fc_props.preload_loading = 'Išankstinis įkėlimas';
_fc_props.preload_loaded = 'Iš anksto įkelta';
_fc_props.send = 'Siųsti';
_fc_props.deliveries_iframe_url = 'Pristatymų IFrame URL';
_fc_props.bulk_ticket_completion = 'Masinis bilietų užpildymas';
_fc_props.ticket_type = 'Bilieto tipas';
_fc_props.complete_tickets = 'Užpildykite bilietus';
_fc_props.tickets_found = 'Rasta bilietų';
_fc_props.include_preload = 'Įtraukti išankstinį įkėlimą';
_fc_props.exclude_preload = 'Išskleisti išankstinį įkėlimą';
_fc_props.selected_tickets = 'Pasirinkti bilietai';
_fc_props.are_you_sure_you_want_to_complete_selected_tickets = 'Ar tikrai norite užbaigti pasirinktus bilietus?';
_fc_props.completing_tickets = 'Užpildomi_bilietai';
_fc_props.some_tickets_failed_to_complete = 'Kai kurių bilietų nepavyko užbaigti';
_fc_props.bulk_ticket_complete_failed = 'Masinis užklausos užbaigimas nepavyko';
_fc_props.ticket_management = 'Bilietų valdymas';
_fc_props.invalid_url_for_deliveries = 'Neteisingas pristatymo URL adresas';
_fc_props.menu_dvir_title_translations = 'Vertimai';
_fc_props.cloud_dvir__dvir_translation = 'Vertimas';
_fc_props.template = 'Šablonas';
_fc_props.menu_dvir_title_admin_translations = 'Vertimai';
_fc_props.menu.dvir.description.translations = 'Peržiūrėti DVIR vertimus';
_fc_props.cloud_dvir__driver_review = 'Vairuotojo apžvalga';
_fc_props.cloud_dvir__mechanic_review = 'Mechaniko apžvalga';
_fc_props.cloud_dvir__driver_approval = 'Vairuotojo patvirtinimas';
_fc_props.cloud_dvir__dvir_event_type = 'DVIR įvykio tipas';
_fc_props.cloud_dvir__option_print_signed = 'Spausdintas pasirašytas';
_fc_props.deliveries_cloud_auth_enabled = 'Pristatymams naudoti debesies autentifikavimą';
_fc_props.deliveries_host_name = 'Pristatymų prieglobos pavadinimas';
_fc_props.cloud_dvir__option_event_history = 'Įvykių istorija';
_fc_props.ticketed_plant = 'Bilietų turintis augalas';
_fc_props.cloud_dvir__all_notes_and_photos_will_be_removed = 'Visos pastabos ir nuotraukos bus pašalintos';
_fc_props.cloud_dvir__continue = 'Tęsti';
_fc_props.cloud_dvir__cancel = 'Atšaukti';
_fc_props.engine_diagnostic_canbaudrate_1 = 'CAN 1';
_fc_props.engine_diagnostic_canbaudrate_2 = 'CAN 2';
_fc_props.attached = 'Prisegtas';
_fc_props.cloud_dvir__images = 'Vaizdai';
_fc_props.settings.ticket_voided_status_change = 'Kai bilietas anuliuojamas, pakeiskite būseną į';
_fc_props.ticket_voided_status_change_duplication_error = 'Anuliuoto bilieto būsenos pakeitimas: kiekvienam būsenos ciklui galima pasirinkti tik vieną būseną';
_fc_props.cloud_not_sending_events = 'Debesijos objekto ID nustatytas, bet įvykiai į debesį nesiunčiami';
_fc_props.set_ticket_integration_send_to_event_bus = 'Bilietų integravimo nustatymuose nustatykite siuntimo būseną / vietą įvykių tiltui reikšmę „true“';
_fc_props.cloud_missing_loading = 'Debesų integracija su būsena LOADING, kuri reiškia, kad būsenos tipas nenustatytas';
_fc_props.cloud_assign_loading = 'Priskirkite LOADING būseną, kad debesyje būtų pakeista pakrovimo būsena';
_fc_props.cloud_missing_loaded = 'Debesijos integracija su LOADED būsena, kuri reiškia, kad būsenos tipas nenustatytas';
_fc_props.cloud_assign_loaded = 'Priskirkite būseną „PAKRAUTA“, kad debesyje būtų pakeista įkelta būsena';
_fc_props.employee_no_valid_type = 'Darbuotojai, kuriems nepriskirtas galiojantis darbuotojo tipas';
_fc_props.employee_assign_valid_type = 'Patikrinkite, ar visiems darbuotojams priskirtas galiojantis darbuotojo tipas.';
_fc_props.employee_no_valid_home_plant = 'Darbuotojai, kuriems nepriskirtas galiojantis namų ūkio įrenginys';
_fc_props.employee_assign_valid_home_plant = 'Patikrinkite, ar visiems darbuotojams yra priskirtas namų augalas.';
_fc_props.employee_dup_alt_num = 'Darbuotojai su pasikartojančiu alternatyviu darbuotojo numeriu';
_fc_props.employee_fix_dup_alt_num = 'Patikrinkite, ar visi darbuotojai turi unikalų alternatyvų darbuotojo numerį';
_fc_props.employee_type_no_default = 'Nėra numatytojo darbuotojo tipo';
_fc_props.employee_type_assign_default = 'Nustatykite numatytąjį darbuotojo tipą';
_fc_props.equipment_type_no_default = 'Nėra numatytojo įrangos tipo';
_fc_props.equipment_type_assign_default = 'Nustatykite numatytąjį įrangos tipą';
_fc_props.equipment_type_not_used = 'Nepriskirti įrangos tipai';
_fc_props.equipment_type_assign_not_used = 'Pašalinkite nenaudojamus įrangos tipus';
_fc_props.equipment_no_valid_type = 'Įranga be priskirto galiojančio įrangos tipo';
_fc_props.equipment_assign_valid_type = 'Patikrinkite, ar visai įrangai priskirtas galiojantis įrangos tipas.';
_fc_props.equipment_no_valid_home_plant = 'Įranga be priskirto galiojančio pagrindinio įrenginio';
_fc_props.equipment_assign_valid_home_plant = 'Patikrinkite, ar visai įrangai priskirtas pagrindinis įrenginys.';
_fc_props.equipment_no_valid_last_plant = 'Įranga be priskirtos galiojančios paskutinės gamyklos';
_fc_props.equipment_assign_valid_last_plant = 'Patikrinkite, ar visai įrangai priskirtas paskutinis įrenginys.';
_fc_props.equipment_dup_interface_num = 'Įranga su pasikartojančiais sąsajos numeriais';
_fc_props.equipment_fix_dup_interface_num = 'Patikrinkite, ar visa įranga turi unikalų sąsajos numerį';
_fc_props.equipment_no_vin = 'Įranga su debesies DVIR, bet be vin kodo';
_fc_props.equipment_assign_vin = 'Atnaujinkite įrangą, kad turėtumėte vin numerį';
_fc_props.equipment_probe_no_drum_type = 'Įranga su zondo licencija, bet be būgno tipo';
_fc_props.equipment_probe_assign_drum_type = 'Atnaujinkite įrangą, kad būtų būgno tipas';
_fc_props.equipment_drs_no_drum_type = 'Įranga su būgno sukimosi jutikliu, bet be būgno tipo';
_fc_props.equipment_drs_assign_drum_type = 'Atnaujinkite įrangą, kad būtų būgno tipas';
_fc_props.equipment_ed_no_config = 'Įranga su variklio diagnostikos licencija ir be konfigūracijos';
_fc_props.equipment_ed_assign_no_config = 'Atnaujinkite įrangą, kad būtų variklio diagnostikos konfigūracija';
_fc_props.plant_no_dispatch_group = 'Augalai be dispečerinės grupės';
_fc_props.plant_assign_dispatch_group = 'Priskirkite augalus esamoms siuntimo grupėms arba iš naujo išsaugokite augalus, kad priskirtumėte siuntimo grupes';
_fc_props.plant_dup_num = 'Augalas su pasikartojančiais augalų numeriais';
_fc_props.plant_fix_dup_num = 'Patikrinkite, ar visi įrenginiai turi unikalius numerius.';
_fc_props.plant_dup_interface_num = 'Įrenginys su pasikartojančiais sąsajos numeriais';
_fc_props.plant_fix_dup_interface_num = 'Patikrinkite, ar visi įrenginiai turi unikalų sąsajos numerį';
_fc_props.status_types_no_default_hotspot_type = 'Būsenos tipams trūksta numatytojo viešosios prieigos taško tipo';
_fc_props.status_types_assign_default_hotspot_type = 'Nustatykite numatytąjį viešosios prieigos taško tipą pagal būsenos tipą';
_fc_props.hotspot_type_no_valid_enter_status = 'Karštosios zonos tipas, įveskite būseną, kurios nebėra';
_fc_props.hotspot_type_assign_valid_enter_status = 'Atnaujinkite viešosios interneto prieigos taško tipą, kad būtų nurodyta galiojanti būsena arba jos nebūtų';
_fc_props.hotspot_type_no_valid_exit_status = 'Karštosios zonos tipo išėjimo būsena nebėra';
_fc_props.hotspot_type_assign_valid_exit_status = 'Atnaujinkite viešosios prieigos taško tipą, kad jis turėtų galiojančią išėjimo būseną arba jos nebūtų';
_fc_props.hotspot_type_not_usable = 'Hotspot Type yra būsenos tipui, kuris nėra priskirtas jokiam įrangos tipui.';
_fc_props.hotspot_type_fix_not_usable = 'Patvirtinkite karštųjų taškų tipo naudojimą. Jei kuriami šio tipo karštieji taškai, jie nebus rodomi žemėlapyje.';
_fc_props.hotspot_invalid_hotspot_type = 'Nuolatiniam interneto prieigos taškui trūksta interneto prieigos taško tipo';
_fc_props.hotspot_assign_hotspot_type = 'Atnaujinkite viešosios prieigos tašką, kad jame būtų galiojantis viešosios prieigos taško tipas.';
_fc_props.plant_hotspot_conflict = 'Augalų karštosios zonos priskyrimas augalams prieštaringas';
_fc_props.plant_hotspot_fix_conflict = 'Augalui priskirtas augalas skiriasi nuo augalo, priskirto bilieto priskyrime, patikrinkite augalo priskyrimą aktyviojoje zonoje, gali tekti iš naujo sukurti augalo aktyviąją vietą, kad išspręstumėte problemą.';
_fc_props.plant_hotspot_restricted = 'Augalų karštosios zonos lankymas ribojamas tam tikrų bilietų savininkams.';
_fc_props.plant_hotspot_fix_restricted = 'Augalų karštoji zona yra ribojama tam tikriems bilietams, norint ją išspręsti, reikia atkurti augalų karštąją vietą.';
_fc_props.status_type_not_used = 'Būsenos tipas nepriskirtas jokiam įrangos tipui';
_fc_props.status_type_fix_not_used = 'Rekomenduojama ištrinti būsenos tipą, jei jo nereikia';
_fc_props.status_type_no_first = 'Trūksta būsenos tipo Pirmoji būsena';
_fc_props.status_type_fix_no_first = 'Priskirkite pirmąją būseną būsenos tipui';
_fc_props.status_type_no_last = 'Trūksta būsenos tipo Paskutinė būsena';
_fc_props.status_type_fix_no_last = 'Priskirkite paskutinę būseną būsenos tipui';
_fc_props.question_no_input_format = 'Klausime trūksta įvesties formato';
_fc_props.question_assign_input_format = 'Priskirkite klausimui formatą';
_fc_props.ticket_no_concrete_product = 'DRS arba zondo bauda ir trūkstamas kubinių jardų arba kubinių metrų kiekis produkte';
_fc_props.ticket_fix_no_concrete_product = 'Patikrinkite bilieto šaltinį ir patvirtinkite, kad integracija siunčia teisingus matavimo vienetus.';
_fc_props.ticket_preload_no_status_meaning = 'Iš anksto įkelti bilietai, bet trūksta išankstinio įkėlimo būsenos reikšmių';
_fc_props.ticket_preload_assign_status_meaning = 'Išankstinio įkėlimo bilietų sąrankos būsenos reikšmės';
_fc_props.question_setup_no_end_miles = 'Klausimo sąranka nustatyta tik pradinėms mylioms';
_fc_props.question_setup_assign_end_miles = 'Atnaujinkite klausimo nustatymus, kad būtų įtrauktos ir pradinės, ir galutinės mylios';
_fc_props.question_setup_no_begin_miles = 'Klausimo sąranka nustatyta tik baigiamosiomis myliomis';
_fc_props.question_setup_no_end_hours = 'Klausimo sąrankos pradžios valandos nustatytos';
_fc_props.question_setup_assign_end_hours = 'Atnaujinkite klausimo nustatymus, kad būtų įtrauktos ir pradžios, ir pabaigos valandos';
_fc_props.question_setup_no_begin_hours = 'Klausimo sąranka – nustatytos tik pabaigos valandos';
_fc_props.question_setup_no_last_plant = 'Klausimo sąranka nenustato paskutinio įrangos gamyklos';
_fc_props.question_setup_assign_last_plant = 'Atnaujinti klausimo nustatymus, įtraukiant paskutinės įrangos gamyklos nustatymą';
_fc_props.device_not_used = 'Aktyvus įrenginys nenaudotas pastaruosius 6 mėnesius';
_fc_props.device_delete_not_used = 'Patikrinkite, ar įrenginiai vis dar reikalingi';
_fc_props.cloud_integration = 'Debesijos integracija';
_fc_props.user_not_used = 'Svetainės naudotojai neprisijungė daugiau nei 6 mėnesius';
_fc_props.user_delete_not_used = 'Pašalinti vartotojus, kurie neprisijungia';
_fc_props.no_configuration_errors = 'Nėra konfigūracijos klaidų';
_fc_props.configuration_error_summary = 'Konfigūracijos santrauka';
_fc_props.configuration_errors = 'Konfigūracija';
_fc_props.question_setup = 'Klausimo sąranka';
_fc_props.plant_no_default = 'Nėra numatytojo augalo';
_fc_props.plant_assign_default = 'Nustatykite numatytąjį augalą';
_fc_props.master_data_error_logs = 'Pagrindinių duomenų klaidų žurnalai';
_fc_props.master_data_error_logs_fetch_failed = 'Pagrindinių duomenų klaidų žurnalų gavimas nepavyko';
_fc_props.equipment_flow_meter_no_pulse = 'Įranga turi srauto matuoklį, bet nerodo tūrio vienam impulsui';
_fc_props.equipment_flow_meter_fix_no_pulse = 'Priskirkite srauto matuoklio tūrį impulsui ant įrangos';
_fc_props.equipment_flow_meter_no_unit = 'Įranga turi srauto matuoklį, bet vandens blokas nepasirinktas';
_fc_props.equipment_flow_meter_fix_no_unit = 'Priskirkite vandens matavimo vienetą įrangos srauto matuokliui';
_fc_props.warn = 'Įspėti';
_fc_props.security = 'Saugumas';
_fc_props.error_validating_master_data_entity_not_found = 'Klaida tikrinant pagrindinius duomenis, objektas nerastas';
_fc_props.device_message_queue_not_assigned = '„device_message_queue_id“ arba „device_message_canary_queue_id“ nėra priskirti duomenų bazės serveryje pagrindinio kompiuterio pavadinimui';
_fc_props.device_message_queue_not_assigned_resolution = 'Reikalingas galiojantis device_message_queue_id ir device_message_canary_queue_id duomenų bazės serveryje.';
_fc_props.talk_queue_not_assigned = '„talk_queue_id“ arba „talk_canary_queue_id“ nėra priskirti duomenų bazės serveryje, skirtame pagrindinio kompiuterio pavadinimui';
_fc_props.talk_queue_not_assigned_resolution = 'Duomenų bazės serveryje reikalingas galiojantis „talk_queue_id“ ir „talk_canary_queue_id“.';
_fc_props.device_message_queue_dne = 'device_message_queue_id neegzistuoja su database_server_id';
_fc_props.device_message_queue_dne_resolution = 'Reikalingas galiojantis device_message_queue_id duomenų bazės serverio lentelei';
_fc_props.device_message_canary_queue_dne = 'device_message_canary_queue_id neegzistuoja su duomenų bazės_serverio_id';
_fc_props.device_message_canary_queue_dne_resolution = 'Reikalingas galiojantis device_message_canary_queue_id duomenų bazės serverio lentelei';
_fc_props.talk_queue_id_dne = '„talk_queue_id“ neegzistuoja su duomenų bazės serverio ID';
_fc_props.talk_queue_id_dne_resolution = 'Reikalingas galiojantis talk_queue_id duomenų bazės_serverio lentelei';
_fc_props.talk_canary_queue_id_dne = '„talk_canary_queue_id“ neegzistuoja su duomenų bazės serverio ID.';
_fc_props.talk_canary_queue_id_dne_resolution = 'Reikalingas galiojantis talk_canary_queue_id duomenų bazės_serverio lentelei';
_fc_props.device_message_queue_no_default = 'device_message_queue trūksta numatytosios reikšmės';
_fc_props.device_message_queue_no_default_resolution = 'Priskirkite numatytąją reikšmę device_message_queue';
_fc_props.message_queue_url_dne = '„message_queue_url“ yra nulinis „device_message_queue“ lauke';
_fc_props.message_queue_url_dne_resolution = 'Reikalingas galiojantis message_queue_url adresas device_message_queue lauke';
_fc_props.talk_queue_url_dne = '„talk_queue_url“ yra nulinis „device_message_queue“ lauke';
_fc_props.talk_queue_url_dne_resolution = 'Reikalingas galiojantis talk_queue_url adresas device_message_queue lauke';
_fc_props.database_server_id_dne = 'įmonės duomenų bazės_serverio_id neegzistuoja';
_fc_props.database_server_id_dne_resolution = 'Reikalingas galiojantis database_server_id duomenų bazės_serverio lentelėje';
_fc_props.dbname_assigned_dne = 'duomenų bazės pavadinimas priskirtas vartotojams, bet įmonės nėra';
_fc_props.dbname_assigned_dne_resolution = 'Pašalinti iš įrašų iš user_db, kur nėra dbname';
_fc_props.canary_totals = 'Kanarų salos';
_fc_props.failed_to_find_trackit_environment = 'Nepavyko rasti „TrackItEnvironment“';
_fc_props.failed_to_find_trackit_environment_resolution = 'Greičiausiai pagrindinio kompiuterio pavadinimas nėra susietas su „TrackItEnvironment“.';
_fc_props.quartz_jobs_not_scheduled = 'Trūkstami kvarco darbai';
_fc_props.quartz_jobs_not_scheduled_resolution = 'Suplanuokite trūkstamus darbus';
_fc_props.database_dne_for_company = 'Įmonės duomenų bazės nėra';
_fc_props.database_dne_for_company_resolution = 'Pašalinkite įmonę iš įmonės lentelės, taip pat iš vartotojo_db lentelės';
_fc_props.deliveries_not_using_cloud_auth = 'Pristatymai nenaudoja debesies autentifikavimo';
_fc_props.deliveries_not_using_cloud_auth_resolution = 'Įgalinkite debesies autentifikavimą pristatymams bilietų integravimo nustatymuose';
_fc_props.talk_using_quartz_scheduler = 'Pokalbyje naudojamas „Quartz“ planuoklis';
_fc_props.talk_using_quartz_scheduler_resolution = 'Svetainės nustatymuose įgalinkite „Use AWS for Talk“';
_fc_props.data_migration_scheduled_and_shouldnt = 'Duomenų perkėlimas yra suplanuotas ir neturėtų būti';
_fc_props.data_migration_scheduled_and_shouldnt_resolution = 'Išjungti duomenų perkėlimo „Quartz“ užduotį';
_fc_props.data_migration_not_scheduled = 'Duomenų perkėlimas nėra suplanuotas ir turėtų būti';
_fc_props.data_migration_not_scheduled_resolution = 'Įgalinti duomenų perkėlimo „Quartz“ užduotį';
_fc_props.data_migration_not_allowed = 'Duomenų perkėlimas neleidžiamas';
_fc_props.data_migration_allowed_on = 'Duomenų perkėlimas leidžiamas';
_fc_props.enable_data_migration = 'Įgalinti duomenų perkėlimą kiekvienai įmonei';
_fc_props.disable_data_migration = 'Išjungti duomenų perkėlimą kiekvienai įmonei';
_fc_props.delayed_jobs_resolution = 'Iš naujo sukurti trigerius, ištrinti trigerius arba paleisti „QuartzManager“ iš naujo';
_fc_props.environment_setup = 'Aplinkos santrauka';
_fc_props.deprecated = 'Nebenaudojamas';
_fc_props.quartz_scheduler = 'Kvarco planuoklė';
_fc_props.device_queues = 'Įrenginių eilės';
_fc_props.data_migration = 'Duomenų migracija';
_fc_props.delayed_jobs = 'Uždelsti darbai';
_fc_props.hide_find_truck_menu_option = 'Slėpti meniu parinktį „Rasti sunkvežimį“';
_fc_props.configuration_audit_info = 'Konfigūracijos audito informacija';
_fc_props.the_master_data_is_not_enabled_yet = 'Pagrindiniai duomenys dar neįjungti';
_fc_props.the_master_data_enablement_audit_info = 'Vartotojas {0} pakeitė pagrindinius duomenis';
_fc_props.on_lower = 'įjungta';
_fc_props.enabled_lower = 'įjungtas';
_fc_props.disabled_lower = 'neįgalus';
_fc_props.mechanic_updated_successfully = 'Mechanikas sėkmingai atnaujintas.';
_fc_props.no_audit_record = 'Nėra audito įrašo.';
_fc_props._7_years = '7 metai (archyvas)';
_fc_props.retention_continue = 'Tęsti';
_fc_props.retention_save_confirm_message = 'Tai paveiks serveryje saugomų duomenų kiekį, o pašalintų duomenų NEGALIMA ATKURTI. Ar norite tęsti?';
_fc_props.cloud_dvir__uom_change_confirmation_title = 'Odometro vienetų ir verčių patvirtinimas';
_fc_props.cloud_dvir__uom_change_confirmation = 'Dabartinė odometro vertė yra {{engineValue}} {{engineUom}}, o įvesta odometro vertė yra {{fromValue}} {{fromUom}}. Ar tai teisinga?';

export default _fc_props;
